import React, { Component } from 'react'
import HexTypes from '../HexTypes'
import Select from './helpers/Select'
import Slider from '../../logicTwo/panels/helpers/Slider'
// import componentProps from '../../../componentProps'
import IOComponents from '../../logic/IOComponents'
import logicVariables from '../../logic/logicVariables'
import PortValuesRangeMapping from '../PortValuesRangeMapping'
import unicodeToChar from '../../../utils/unicodeToChar'
import { connect } from 'react-redux'
import { webSerialConnect } from '../../../redux/actions/index'
import { rangeStoreVal } from '../../Assembly/CheckboxData'
import renderPrgImage from '../../../source/programImg'
import { gestureValueToText } from '../../../utils'
// import DecisionPanel from '../../Humanoid/DecisionPanel'
import {
    sendBytes,
    continousPABytesReadToggle_v1,
    readBytesPa,
} from '../../ReusableComponents/ByteTransfer'
import {
    klawPABytesToSensorData,
    mokiPABytesToSensorData,
    pcAiTool_PABytesToSensorData,
    playComputerPABytesToSensorData,
    pokiPABytesToSensorData,
    robokiPABytesToSensorData,
} from '../../ReusableComponents/ByteTransfer/utils'
import DecisionPanel from '../../Humanoid/DecisionPanel'
import {
    aiItemsData,
    getPaBytesAi,
    paBytesAi,
} from '../../../source/assemblyPageAiData'
import {
    getDeviceName,
    isAi1NotPresent,
    isAi1ShowCondition,
} from '../../../utils/utils'
import DialogModal from '../../ReusableComponents/DialogModal/DialogModal'
import renderImage from '../../../source/importImg'
import { appAiBytesGeneration } from '../../AppMode/AppModeAI/AppModeAiBytesGeneration'
import PanelHighlightContext, {
    isKeyHighlighted,
    isConditionHighlighted,
} from '../PanelHighlightContext'

// var componentType = localStorage.getItem("biboxTypes");
// setInterval(() => {
//     componentType = localStorage.getItem("biboxTypes");
// } 100);
const hours = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    10: 10,
    11: 11,
    12: 12,
    13: 13,
    14: 14,
    15: 15,
    16: 16,
    17: 17,
    18: 18,
    19: 19,
    20: 20,
    21: 21,
    22: 22,
    23: 23,
}
const minutes = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    10: 10,
    11: 11,
    12: 12,
    13: 13,
    14: 14,
    15: 15,
    16: 16,
    17: 17,
    18: 18,
    19: 19,
    20: 20,
    21: 21,
    22: 22,
    23: 23,
    24: 24,
    25: 25,
    26: 26,
    27: 27,
    28: 28,
    29: 29,
    30: 30,
    31: 31,
    32: 32,
    33: 33,
    34: 34,
    35: 35,
    36: 36,
    37: 37,
    38: 38,
    39: 39,
    40: 40,
    41: 41,
    42: 42,
    43: 43,
    44: 44,
    45: 45,
    46: 46,
    47: 47,
    48: 48,
    49: 49,
    50: 50,
    51: 51,
    52: 52,
    53: 53,
    54: 54,
    55: 55,
    56: 56,
    57: 57,
    58: 58,
    59: 59,
}

var reader

const conditionDisabledStyle = {
    cursor: 'default',
    opacity: '0.5',
}

class IfPanel extends Component {
    static contextType = PanelHighlightContext
    constructor(props) {
        super(props)
        this.sendDataRef = React.createRef()
        this.sendDataRef.current = { sendDataAsPacket: false, readVal: '' }
        this.connectStatusRef = React.createRef()
        this.connectStatusRef.current = {
            isIMUConnect: false,
            isColor_sensorConnect: false,
        }

        const { state, onChange } = this.props
        if (Object.keys(state).length <= 0) {
            state['source'] = 'battery'
            state['value'] = 0
            state['value2'] = 0
            state['hour'] = 0
            state['hour2'] = 0
            state['minute'] = 0
            state['minute2'] = 0
            onChange(state, 'sensor') // <-- MOVED INSIDE THE IF BLOCK
        }
        
        // try {
        //     this.aiTrainList = JSON.parse(localStorage.getItem('aiTrainList'))
        // } catch {
        //     this.aiTrainList = {}
        // }
        this.state = {
            recentGesture: 0,
            state,
            k: false,
            isGraterThan: false,
            isLessThan: false,
            isNotequalTo: false,
            isEqualTo: false,
            isInBtween: false,
            isRead: false,
            isRead_v1: false,
            Bytes: false,
            accelerometer_X: '',
            accelerometer_Y: '',
            accelerometer_Z: '',
            gyro_X: '',
            gyro_Y: '',
            gyro_Z: '',
            responceTp0: '',
            responceTp1: '',
            responceTp2: '',
            touch_pad: '',
            touch_pad2: '',
            rangeA1: '',
            rangeA2: '',
            rangeB1: '',
            rangeB2: '',
            rangeC1: '',
            rangeC2: '',
            rangeD1: '',
            rangeD2: '',
            rangeE1: '',
            rangeE2: '',
            rangeF1: '',
            rangeF2: '',
            rangeG1: '',
            rangeG2: '',
            rangeservo_motor1: '',
            rangeservo_motor2: '',
            tactswitch: '',
            tact_switch_2c: '',
            battery: '',
            zero: '',
            mic: '',
            temprature: '',
            temp: '',
            gas: '',
            one: '',
            two: '',
            red: '',
            green: '',
            blue: '',
            light: '',
            gesture: '',
            distance: '',
            switch1: '',
            switch2: '',
            pcAiTool_read_value: '',
            ir: '',
            readToggel: false,
            showPopup: false,

            //klaw
            // joystick1_X: '',
            // joystick1_Y: '',
            // joystick2_X: '',
            // joystick2_Y: '',
            // joystick3_X: '',
            // joystick3_Y: '',
            // switch1: '',
            // switch2: '',
            // switch3: '',
            // pwm1: '',
            // pwm2: '',
            // pwm3: '',
            // pwm4: '',
            // pwm5: '',
            // pwm6: '',
            lowerVersionPcAiToolShow: { isShow: false, message: '', type: '' },
        }

        this.messageHandler = this.messageHandler.bind(this)
        this.connectedDevice =
            sessionStorage.getItem('connectedDevice') || 'Ace'
    }

    componentDidUpdate(prevProps) {
        // Auto-apply read source during tutorial replay
        const blockState = this.props.state
        if (
            blockState &&
            blockState._readSource &&
            blockState._readSource !== this.state.readToggel
        ) {
            this.setState({ readToggel: blockState._readSource })
        }
    }

    outputGesture = (val) => {
        // return val;
        if (val != 0) {
            this.state.recentGesture = val
        }
        return this.state.recentGesture
    }

    hexTypeCheck = () => {
        this.props.hexTypeCheck('sensor')
    }

    /////////////////////////  Read and write for version 0.1.13 ////////////////////////
    async readdata() {
        const port = this.props.webSerial.port
        // eslint-disable-next-line no-undef
        const textDecoder = new TextDecoderStream()
        try {
            // eslint-disable-next-line no-undef
            const readableStreamClosed = port.readable.pipeTo(
                textDecoder.writable
            )
        } catch {}

        // const readableStreamClosed = port.readable.pipeTo(textDecoder.writable);
        reader = textDecoder.readable.getReader()
        var i = 1
        var combiBytes = []
        while (true) {
            const { value, done } = await reader.read()
            // console.log("VALUES", value, value.length);

            try {
                combiBytes = [...combiBytes, ...value]
            } catch (e) {}

            if (combiBytes.includes(`\n`)) {
                this.state.Bytes = combiBytes.join('')
                console.log(combiBytes.join(''), 'comb')
                combiBytes = []
            }
            // i++;
            // console.log("lxlxl", value);
            console.log('lxlxl', combiBytes)
            if (this.state.k == true) {
                console.log('MAI CHAL GAYA')
                reader.releaseLock()
                break
            }

            if (done) {
                // Allow the serial port to be closed later.
                reader.releaseLock()
                break
            }
            // value is a string.
            console.log(value)
        }
        // try {
        //   const reader = port.readable.getReader();
        //   var i = 1;
        //   var combiBytes = [];
        //   // Listen to data coming from the serial device.
        //   while (true) {
        //     const { value, done } = await reader.read();
        //     combiBytes = [...combiBytes, ...value];
        //     i++;
        //     if (this.state.k === true) {
        //       console.log("MAI CHAL GAYA");
        //       reader.releaseLock();
        //       break;
        //     }
        //     if (i == 2) {
        //       console.log("PABYTES", unicodeToChar(combiBytes));
        //       reader.releaseLock();
        //       this.state.Bytes = unicodeToChar(combiBytes);
        //       break;
        //     }
        //     // value is a string.
        //     if (value.length == 32) {
        //       var v = unicodeToChar(value);
        //       console.log(v);
        //     }
        //     if (value.length == 7) {
        //       var vi = unicodeToChar(value);
        //       console.log(vi);
        //     }
        //     if (value.length == 9) {
        //       var vi = unicodeToChar(value);
        //       console.log(vi);
        //     }
        //     if (value.length == 14) {
        //       var vi = unicodeToChar(value);
        //       console.log(vi);
        //     }
        //     if (value.length == 17) {
        //       var vi = unicodeToChar(value);
        //       console.log(vi);
        //     }
        //     if (value.length == 12) {
        //       var vi = unicodeToChar(value);
        //       console.log(vi);
        //     }
        //     if ((value.lenght == 32 && value.lenght == 12) || value.lenght == 11) {
        //       var vae = v + " " + vi;
        //       console.log(vae, "ORRRR");
        //     }
        //     var vae = v + vi;

        //     console.log("ADDED I", vae);
        //     // this.state.Bytes = vae;
        //   }
        // } catch (e) {
        //   console.log(e);
        // }
    }
    MSBLSBToDecimal = (MSBInBinary, LSBInBinary) => {
        return parseInt(
            parseInt(MSBInBinary).toString(2).padStart(8, 0) +
                parseInt(LSBInBinary).toString(2).padStart(8, 0),
            2
        )
    }
    setPABytes_v01 = async (data) => {
        if (data === undefined) return
        data = data.filter((e) => e != 80 && e != 65)
        console.log(this.MSBLSBToDecimal(data[1], data[0]), 'gsk read')
        this.setState({
            zero: this.MSBLSBToDecimal(data[1], data[0]),
            one: this.MSBLSBToDecimal(data[5], data[4]),
            two: this.MSBLSBToDecimal(data[9], data[8]),
            rangeA1: this.MSBLSBToDecimal(data[1], data[0]),
            rangeA2: this.MSBLSBToDecimal(data[3], data[2]),
            rangeB1: this.MSBLSBToDecimal(data[5], data[4]),
            rangeB2: this.MSBLSBToDecimal(data[7], data[6]),
            rangeC1: this.MSBLSBToDecimal(data[9], data[8]),
            rangeC2: this.MSBLSBToDecimal(data[11], data[10]),
            rangeF1: data[12],
            rangeF2: data[13],
            red: data[14],
            green: data[15],
            blue: data[16],
            light: this.MSBLSBToDecimal(data[15], data[14]),
            distance: data[15],
            gesture: data[16],
            mic: this.MSBLSBToDecimal(data[18], data[17]),
            temprature: this.MSBLSBToDecimal(data[20], data[19]),
        })
    }
    getBytesToSend() {
        let bytesData = Array(11).fill('O'.charCodeAt())

        bytesData.unshift('A'.charCodeAt())
        bytesData.unshift('P'.charCodeAt())

        let sessionData = JSON.parse(sessionStorage.getItem('concept'))
        console.log(sessionData, 'sessiondatadatadatadat')
        console.log(sessionData.internalaccessories, 'Internal data')

        let portdata = JSON.parse(sessionStorage.getItem('assemblyTwo'))
        console.log(
            portdata.PortConnections,
            '<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<DATA>>>>>>>>>>>>>>>>>'
        )
        console.log(portdata.PortConnections, '>>???>>>>????<<<<')
        // console.log("TYPE:-", portdata.PortConnections);
        // Obect.keys and Object.values n

        Object.keys(portdata.PortConnections).map((port) => {
            if (portdata.PortConnections[port] != null) {
                if (port === 'A' || port === 'A1' || port === 'A2') {
                    let Type = portdata.PortConnections[port].type

                    if (Type == 'ultrasonic_sensor') {
                        bytesData[2] = 'U'.charCodeAt()
                        // bytesData[3] = "I".charCodeAt();
                    } else if (
                        Type == 'tact_switch' ||
                        Type == 'touch_sensor' ||
                        Type == 'dual_switch' ||
                        Type == 'dip_switch' ||
                        Type == 'metal_detector'
                    ) {
                        if (port == 'A') {
                            bytesData[2] = 'I'.charCodeAt()
                            bytesData[3] = 'I'.charCodeAt()
                        }
                        if (port == 'A1') bytesData[2] = 'I'.charCodeAt()
                        if (port == 'A2') bytesData[3] = 'I'.charCodeAt()
                    } else if (
                        Type == 'distance_sensor' ||
                        Type == 'temperature_sensor' ||
                        Type == 'gas' ||
                        Type == 'light_sensor' ||
                        Type == 'linear_pot' ||
                        Type == 'pot' ||
                        Type == 'rain_sensor' ||
                        Type == 'humidity'
                    ) {
                        if (port == 'A') {
                            bytesData[2] = 'A'.charCodeAt()
                            bytesData[3] = 'A'.charCodeAt()
                        }
                        if (port == 'A1') bytesData[2] = 'A'.charCodeAt()
                        if (port == 'A2') bytesData[3] = 'A'.charCodeAt()
                    } else if (
                        Type == 'rotatory' ||
                        Type == 'joystick' ||
                        Type == 'extender'
                    ) {
                        bytesData[2] = 'A'.charCodeAt()
                        bytesData[3] = 'A'.charCodeAt()
                    }
                } else if (port === 'B' || port === 'B1' || port === 'B2') {
                    let Type = portdata.PortConnections[port].type

                    if (
                        Type == 'rotatory' ||
                        Type == 'joystick' ||
                        Type == 'extender'
                    ) {
                        bytesData[4] = 'A'.charCodeAt()
                        bytesData[5] = 'A'.charCodeAt()
                    } else if (
                        Type == 'distance_sensor' ||
                        Type == 'temperature_sensor' ||
                        Type == 'gas' ||
                        Type == 'light_sensor' ||
                        Type == 'linear_pot' ||
                        Type == 'pot' ||
                        Type == 'rain_sensor' ||
                        Type == 'humidity'
                    ) {
                        if (port == 'B') {
                            bytesData[4] = 'A'.charCodeAt()
                            bytesData[5] = 'A'.charCodeAt()
                        }
                        if (port == 'B1') bytesData[4] = 'A'.charCodeAt()
                        if (port == 'B2') bytesData[5] = 'A'.charCodeAt()
                    } else if (
                        Type == 'tact_switch' ||
                        Type == 'touch_sensor' ||
                        Type == 'dual_switch' ||
                        Type == 'dip_switch' ||
                        Type == 'metal_detector'
                    ) {
                        if (port == 'B') {
                            bytesData[4] = 'I'.charCodeAt()
                            bytesData[5] = 'I'.charCodeAt()
                        }
                        if (port == 'B1') bytesData[4] = 'I'.charCodeAt()
                        if (port == 'B2') bytesData[5] = 'I'.charCodeAt()
                    }
                } else if (port === 'C' || port === 'C1' || port === 'C2') {
                    let Type = portdata.PortConnections[port].type

                    if (Type == 'ultrasonic_sensor') {
                        bytesData[6] = 'U'.charCodeAt()
                        // bytesData[7] = "A".charCodeAt();
                    } else if (
                        Type == 'tact_switch' ||
                        Type == 'touch_sensor' ||
                        Type == 'dual_switch' ||
                        Type == 'dip_switch' ||
                        Type == 'metal_detector'
                    ) {
                        if (port == 'C') {
                            bytesData[6] = 'I'.charCodeAt()
                            bytesData[7] = 'I'.charCodeAt()
                        }
                        if (port == 'C1') bytesData[6] = 'I'.charCodeAt()
                        if (port == 'C2') bytesData[7] = 'I'.charCodeAt()
                    } else if (
                        Type == 'distance_sensor' ||
                        Type == 'temperature_sensor' ||
                        Type == 'gas' ||
                        Type == 'light_sensor' ||
                        Type == 'linear_pot' ||
                        Type == 'pot' ||
                        Type == 'rain_sensor' ||
                        Type == 'humidity'
                    ) {
                        if (port == 'C') {
                            bytesData[6] = 'A'.charCodeAt()
                            bytesData[7] = 'A'.charCodeAt()
                        }
                        if (port == 'C1') bytesData[6] = 'A'.charCodeAt()
                        if (port == 'C2') bytesData[7] = 'A'.charCodeAt()
                    } else if (
                        Type == 'rotatory' ||
                        Type == 'joystick' ||
                        Type == 'metal_detector' ||
                        Type == 'extender'
                    ) {
                        bytesData[6] = 'A'.charCodeAt()
                        bytesData[7] = 'A'.charCodeAt()
                    }
                } else if (port === 'F' || port === 'F1' || port === 'F2') {
                    let Type = portdata.PortConnections[port].type

                    if (
                        Type == 'tact_switch' ||
                        Type == 'touch_sensor' ||
                        Type == 'dual_switch' ||
                        Type == 'metal_detector' ||
                        Type == 'dip_switch' ||
                        Type == 'tact_switch_2c'
                    ) {
                        if (port == 'F1') bytesData[8] = 'I'.charCodeAt()
                        if (port == 'F2') bytesData[9] = 'I'.charCodeAt()
                    }
                }
            }
        })

        if (sessionData.internalaccessories.isMic) {
            bytesData[11] = 'M'.charCodeAt()
        }
        if (sessionData.internalaccessories.isTemperature) {
            bytesData[12] = 'T'.charCodeAt()
        }
        if (sessionData.internalaccessories.isTouchZero) {
            bytesData[2] = 'T'.charCodeAt()
        }
        if (sessionData.internalaccessories.isTouchOne) {
            bytesData[4] = 'T'.charCodeAt()
        }
        if (sessionData.internalaccessories.isTouchTwo) {
            bytesData[6] = 'T'.charCodeAt()
        }

        if (
            sessionData.internalaccessories.Four_in_one_sensor.isDistanceSensors
        ) {
            bytesData[10] = 'D'.charCodeAt()
        }
        if (
            sessionData.internalaccessories.Four_in_one_sensor.isGestureSensor
        ) {
            bytesData[10] = 'G'.charCodeAt()
        }
        if (sessionData.internalaccessories.Four_in_one_sensor.isColorSensor) {
            bytesData[10] = 'C'.charCodeAt()
        }
        if (sessionData.internalaccessories.Four_in_one_sensor.isLightSensor) {
            bytesData[10] = 'L'.charCodeAt()
        }
        return bytesData
    }
    handleReadByte = async () => {
        if (!this.props.webSerial.isConnected) {
            await this.setState({ isRead: false })
        }
        await this.setState({ isRead: !this.state.isRead })
        let flag = true
        while (true) {
            console.log('check read state', this.state.isRead)
            if (!this.state.isRead && this.props.webSerial.isConnected) {
                setTimeout(() => {
                    this.props.worker.postMessage({
                        type: 'write',
                        value: 'M8',
                    })
                }, 500)
                return
            }
            if (!this.state.isRead || !this.props.webSerial.isConnected) {
                this.recievedBytes_Pcv01([
                    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0,
                ])

                return
            }
            if (flag) {
                // await sendBytes(
                //     [
                //         'M'.charCodeAt(0),
                //         '8'.charCodeAt(0),
                //     ],
                //     this.props.webSerial.port
                // )
                flag = false
                await new Promise((resolve) => setTimeout(resolve, 200))
            } else {
                //temp fix for page haulting problem
                this.props.worker.postMessage({
                    type: 'writeArray',
                    value: this.getBytesToSend(),
                })
                await new Promise((resolve) => setTimeout(resolve, 100))
            }
        }
    }
    async writePort(data) {
        sendBytes(data, this.props.webSerial.port)
    }
    /////////////////////////////////////////////////////////////////////////////////////

    ////////////////////////  Read and write for version 1.0.01 /////////////////////////
    PokiGetIndex = (port) => {
        switch (port) {
            case 'A1':
                return 2
            case 'A2':
                return 3
            case 'C1':
                return 4
            case 'C2':
                return 5
            case 'D1':
                return 6
            case 'D2':
                return 7
            case 'E1':
                return 8
            case 'E2':
                return 9
            case 'F1':
                return 10
            case 'F2':
                return 11
            case 'G1':
                return 12
            case 'G2':
                return 13
            case 'servo_motor1':
                return 14
            case 'servo_motor2':
                return 15
        }
    }
    setPABytes_V1() {
        let connectedDevice = sessionStorage.getItem('connectedDevice')
        let sendBytes = []
        if (connectedDevice == 'Toki') {
            sendBytes = Array(9).fill('0')

            sendBytes[0] = 'P'.codePointAt(0)
            sendBytes[1] = 'A'.codePointAt(0)
            sendBytes[7] = 'E'.codePointAt(0)
            sendBytes[8] = 'R'.codePointAt(0)
        } else if (connectedDevice == 'Poki') {
            this.connectStatusRef.current = {
                isIMUConnect: false,
                isColor_sensorConnect: false,
            }

            sendBytes = Array(19).fill('0')

            sendBytes[0] = 'P'.codePointAt(0)
            sendBytes[1] = 'A'.codePointAt(0)
            sendBytes[17] = 'E'.codePointAt(0)
            sendBytes[18] = 'R'.codePointAt(0)
        } else if (connectedDevice == 'Poki') {
            sendBytes = Array(19).fill('0')

            sendBytes[0] = 'P'.codePointAt(0)
            sendBytes[1] = 'A'.codePointAt(0)
            sendBytes[17] = 'E'.codePointAt(0)
            sendBytes[18] = 'R'.codePointAt(0)
        } else if (connectedDevice === 'Moki') {
            this.connectStatusRef.current = {
                isIMUConnect: false,
                isColor_sensorConnect: false,
            }
            sendBytes = Array(25).fill('0')

            sendBytes[0] = 'P'.codePointAt(0)
            sendBytes[1] = 'A'.codePointAt(0)
            sendBytes[19] = 'E'.codePointAt(0)
            sendBytes[20] = 'R'.codePointAt(0)
        } else {
            sendBytes = Array(25).fill('0')

            sendBytes[0] = 'P'.codePointAt(0)
            sendBytes[1] = 'A'.codePointAt(0)
            sendBytes[23] = 'E'.codePointAt(0)
            sendBytes[24] = 'R'.codePointAt(0)
        }

        let portConnections = this.props.assembly.PortConnections
        let internalAccessories = this.props.concept.internalaccessories
        Object.keys(portConnections).map((port) => {
            if (
                port !== 'A' &&
                port !== 'B' &&
                port !== 'C' &&
                port !== 'D' &&
                portConnections[port] !== null
            ) {
                const getIndex = (port) => {
                    switch (port) {
                        case 'A1':
                            return 2
                        case 'A2':
                            return 3
                        case 'B1':
                            return 4
                        case 'B2':
                            return 5
                        case 'C1':
                            return 6
                        case 'C2':
                            return 7
                        case 'D1':
                            return 8
                        case 'D2':
                            return 9
                        case 'E1':
                            return 10
                        case 'E2':
                            return 11
                        case 'F1':
                            return 12
                        case 'F2':
                            return 13
                        case 'G1':
                            return 14
                        case 'G2':
                            return 15
                    }
                }
                const tokiIndex = (port) => {
                    switch (port) {
                        case 'servo_motor1':
                            return 4
                        case 'servo_motor2':
                            return 5
                    }
                }

                let arrIndex
                if (connectedDevice == 'Poki') {
                    arrIndex = this.PokiGetIndex(port)
                } else {
                    arrIndex = getIndex(port)
                }
                if (
                    connectedDevice == 'Toki' &&
                    ['servo_motor1', 'servo_motor2'].includes(port)
                ) {
                    arrIndex = tokiIndex(port)
                }

                let Type = portConnections[port].type
                if (Type == 'ultrasonic_sensor') {
                    sendBytes[arrIndex] = 'U'.codePointAt(0)
                } else if (
                    [
                        'tact_switch',
                        'dual_switch',
                        'metal_detector',
                        'touch_sensor',
                        'dip_switch',
                        'tact_switch_2c',
                        'capacitative_touch_sensor',
                        'PIR_sensor',
                        'rain_sensor_module_digital',
                        'Digital_2_Pin_Input',
                        'Digital_3_Pin_Input',
                    ].includes(Type)
                ) {
                    sendBytes[arrIndex] = 'I'.codePointAt(0)
                    sendBytes[arrIndex] = 'I'.codePointAt(0)
                } else if (
                    [
                        'distance_sensor',
                        'temperature_sensor',
                        'gas',
                        'light_sensor',
                        'linear_pot',
                        'pot',
                        'rain_sensor',
                        'rain_sensor_module_analog',
                        'humidity',
                        'LDR_sensor',
                        'sound_sensor',
                        'DHT11',
                        'IR_proximity',
                        'Analog_3_Pin_Input',
                        'Analog_2_Pin_Input',
                    ].includes(Type)
                ) {
                    sendBytes[arrIndex] = 'A'.codePointAt(0)
                } else if (
                    Type == 'rotatory' ||
                    Type == 'joystick' ||
                    Type == 'extender'
                ) {
                    sendBytes[arrIndex] = 'A'.codePointAt(0)
                    sendBytes[arrIndex] = 'A'.codePointAt(0)
                } else if (['pcAiTool'].includes(Type)) {
                    getPaBytesAi(this.state.readToggel, sendBytes, arrIndex)
                } else if (Type === 'Magnetometer') {
                    if (this.connectedDevice === 'Moki') {
                        sendBytes[21] = 'Q'.codePointAt(0)
                    } else sendBytes[arrIndex] = 'Q'.codePointAt(0)
                } else if (Type === 'Color_sensor') {
                    this.connectStatusRef.current = {
                        isIMUConnect: false,
                        isColor_sensorConnect: true,
                    }

                    if (connectedDevice === 'Moki') {
                        sendBytes[20] = 'C'.codePointAt(0)
                    } else sendBytes[arrIndex] = 'C'.codePointAt(0)
                } else if (Type === 'Magnetic_encoder') {
                    sendBytes[arrIndex] = 'E'.codePointAt(0)
                } else if (Type === 'IMU') {
                    this.connectStatusRef.current = {
                        isIMUConnect: true,
                        isColor_sensorConnect: false,
                    }
                    if (this.connectedDevice === 'Moki') {
                        sendBytes[21] = 'A'.codePointAt(0)
                    } else {
                        sendBytes[arrIndex] = 'G'.codePointAt(0)
                        sendBytes[arrIndex + 1] = 'G'.codePointAt(0)
                    }
                }
            }
        })
        if (connectedDevice == 'Ace') {
            if (internalAccessories.isMic) {
                sendBytes[14] = 'M'.codePointAt(0)
            }
            if (internalAccessories.isTemperature) {
                sendBytes[15] = 'T'.codePointAt(0)
            }
            if (internalAccessories.isTouchZero) {
                sendBytes[16] = 'T'.codePointAt(0)
            }
            if (internalAccessories.isTouchOne) {
                sendBytes[17] = 'T'.codePointAt(0)
            }
            if (internalAccessories.isTouchTwo) {
                sendBytes[18] = 'T'.codePointAt(0)
            }
            if (internalAccessories.isTouchThree) {
                sendBytes[19] = 'T'.codePointAt(0)
            }
            if (internalAccessories.Four_in_one_sensor.isDistanceSensors) {
                sendBytes[20] = 'D'.codePointAt(0)
            }
            if (internalAccessories.Four_in_one_sensor.isGestureSensor) {
                sendBytes[20] = 'G'.codePointAt(0)
            }
            if (
                internalAccessories.Four_in_one_sensor.isColorSensor &&
                (this.state.readToggel == '4-IN-1 SENSOR  â†’  RED' ||
                    this.state.readToggel == '4-IN-1 SENSOR  â†’  GREEN' ||
                    this.state.readToggel == '4-IN-1 SENSOR  â†’  BLUE')
            ) {
                sendBytes[20] = 'C'.codePointAt(0)
            }
            if (internalAccessories.Four_in_one_sensor.isLightSensor) {
                sendBytes[20] = 'L'.codePointAt(0)
            }
            if (internalAccessories.isAccelerometer) {
                sendBytes[21] = 'A'.codePointAt(0)
            }
            if (internalAccessories.isBattery) {
                sendBytes[22] = 'B'.codePointAt(0)
            }
        } else if (connectedDevice === 'Moki') {
            if (internalAccessories.isIr) {
                sendBytes[16] = 'R'.codePointAt(0)
            }
            if (internalAccessories.isSwitch1) {
                sendBytes[17] = 'I'.codePointAt(0)
            }
            if (internalAccessories.isSwitch2) {
                sendBytes[18] = 'I'.codePointAt(0)
            }
        } else if (connectedDevice === 'Poki') {
            if (internalAccessories.isIr) {
                sendBytes[16] = 'N'.codePointAt(0)
            }
        } else if (connectedDevice === 'Toki') {
            if (internalAccessories.isIr) {
                sendBytes[6] = 'N'.codePointAt(0)
            }
        }
        // sendBytes = sendBytes.toString().replaceAll(',', '')
        // console.log('VVVVVVVVVVVVV', sendBytes)
        return sendBytes
    }

    //set PA bytes for roboki
    setPABytes_Roboki() {
        let sendBytes = Array(10).fill(79) //79 is the ASCI Value of O

        sendBytes[0] = 'P'.codePointAt(0)
        sendBytes[1] = 'A'.codePointAt(0)
        sendBytes[8] = 'E'.codePointAt(0)
        sendBytes[9] = 'R'.codePointAt(0)
        let internalAccessories = this.props.concept.internalaccessories
        let portConnections = this.props.assembly.PortConnections
        Object.keys(portConnections).map((port) => {
            if (
                port !== 'A' &&
                // port !== 'B' &&
                port !== 'C' &&
                // port !== 'D' &&
                portConnections[port] !== null
            ) {
                const getIndex = (port) => {
                    switch (port) {
                        case 'A1':
                            return 2
                        case 'A2':
                            return 3
                        case 'B1':
                            return 4
                        case 'B2':
                            return 5
                        case 'C1':
                            return 6
                        case 'C2':
                            return 7
                    }
                }

                let arrIndex = getIndex(port)
                let Type = portConnections[port].type
                if (Type == 'ultrasonic_sensor') {
                    sendBytes[arrIndex] = 'U'.codePointAt(0)
                } else if (
                    [
                        'tact_switch',
                        'dual_switch',
                        'touch_sensor',
                        'dip_switch',
                        'tact_switch_2c',
                        'tern_tact_switch',
                        'tern_touch_sensor',
                    ].includes(Type)
                ) {
                    sendBytes[arrIndex] = 'I'.codePointAt(0)
                    sendBytes[arrIndex] = 'I'.codePointAt(0)
                } else if (
                    [
                        'distance_sensor',
                        'temperature_sensor',
                        'light_sensor',
                        'pot',
                        'rain_sensor',
                        'tern_humidity_sensor',
                        'tern_gas_sensor',
                        'tern_sound_sensor',
                    ].includes(Type)
                ) {
                    sendBytes[arrIndex] = 'A'.codePointAt(0)
                } else if (
                    Type == 'rotatory' ||
                    Type == 'joystick' ||
                    Type == 'extender'
                ) {
                    sendBytes[arrIndex] = 'A'.codePointAt(0)
                    sendBytes[arrIndex] = 'A'.codePointAt(0)
                } else if (['pcAiTool'].includes(Type) && arrIndex) {
                    getPaBytesAi(this.state.readToggel, sendBytes, arrIndex)
                    // sendBytes[arrIndex] = paBytesAi[this.state.readToggel]
                }
            }
        })

        if (internalAccessories.isSwitch1) {
            sendBytes[6] = 'I'.codePointAt(0)
        }
        if (internalAccessories.isSwitch2) {
            sendBytes[7] = 'I'.codePointAt(0)
        }
        // sendBytes = sendBytes.toString().replaceAll(',', '')
        return sendBytes
    }

    handleReadByte_v1 = async () => {
        console.log('gggggggggggggggggggggg11111111')
        let connectedDevice = sessionStorage.getItem('connectedDevice')
        let deviceVersion = sessionStorage.getItem('deviceVersion')
        let isAi_1Connected = this.props?.assembly?.PortConnections?.A1?.type

        //show the lower version devce that are not support the PcAiTool
        if (
            !isAi1NotPresent({
                connectedDevice,
                deviceVersion,
            }) &&
            isAi_1Connected === 'pcAiTool' &&
            !isAi1ShowCondition({
                connectedDevice,
                deviceVersion,
            }) &&
            !this.state.isRead_v1
        ) {
            this.setState({
                lowerVersionPcAiToolShow: {
                    isShow: true,
                    message: '',
                    type: 'lowerVersion',
                },
            })
        }

        const M8 = new Uint8Array(['M'.charCodeAt(0), '8'.charCodeAt(0)])
        this.setState({ isRead_v1: !this.state.isRead_v1 })
        sessionStorage.setItem('isRead', !this.state.isRead_v1)
        if (!this.state.isRead_v1 === false) {
            return
        }

        while (true) {
            if (
                !JSON.parse(sessionStorage.getItem('isRead')) ||
                !this.props.webSerial.isConnected
            ) {
                this.props.worker.postMessage({
                    type: 'write',
                    value: 'M8',
                })
                sessionStorage.removeItem('isRead')
                return
            } else {
                let sendPAbytes = []
                if (
                    ['Roboki', 'Atr'].includes(
                        sessionStorage.getItem('connectedDevice')
                    )
                ) {
                    sendPAbytes = this.setPABytes_Roboki()
                } else {
                    sendPAbytes = this.setPABytes_V1()
                }
                this.props.worker.postMessage({
                    type: 'writeArray',
                    value: sendPAbytes,
                })
                await new Promise((resolve) => setTimeout(resolve, 100))
            }
        }
    }

    recievedBytes_Pcv01 = (data) => {
        if (data === undefined) return
        data = data.filter((e) => e != 80 && e != 65)
        console.log(this.MSBLSBToDecimal(data[1], data[0]), 'gsk read')
        this.setState({
            zero: this.MSBLSBToDecimal(data[1], data[0]),
            one: this.MSBLSBToDecimal(data[5], data[4]),
            two: this.MSBLSBToDecimal(data[9], data[8]),
            rangeA1: this.MSBLSBToDecimal(data[1], data[0]),
            rangeA2: this.MSBLSBToDecimal(data[3], data[2]),
            rangeB1: this.MSBLSBToDecimal(data[5], data[4]),
            rangeB2: this.MSBLSBToDecimal(data[7], data[6]),
            rangeC1: this.MSBLSBToDecimal(data[9], data[8]),
            rangeC2: this.MSBLSBToDecimal(data[11], data[10]),
            rangeF1: data[12],
            rangeF2: data[13],
            red: data[14],
            green: data[15],
            blue: data[16],
            light: this.MSBLSBToDecimal(data[15], data[14]),
            distance: data[15],
            gesture: data[16],
            mic: this.MSBLSBToDecimal(data[18], data[17]),
            temprature: this.MSBLSBToDecimal(data[20], data[19]),
        })
    }
    recievedBytes_v1 = (bytesRecieved) => {
        console.log(bytesRecieved, 'recievedData')
        if (this.connectedDevice === 'Ace') {
            this.setState({
                rangeA1: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    2
                ),
                rangeA2: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    3
                ),
                rangeB1: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    4
                ),
                rangeB2: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    5
                ),
                rangeC1: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    6
                ),
                rangeC2: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    7
                ),
                rangeD1: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    8
                ),
                rangeD2: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    9
                ),
                rangeE1: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    10
                ),
                rangeE2: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    11
                ),
                rangeF1: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    12
                ),
                rangeF2: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    13
                ),
                mic: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    14
                ),
                temprature: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    15
                ),
                zero: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    16
                ),
                one: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    17
                ),
                temp: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    18
                ),
                two: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    19
                ),
                light: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    '20L'
                ),
                distance: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    '20D'
                ),
                gesture: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    '20G'
                ),
                red: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    '20C'
                )[0],
                green: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    '20C'
                )[1],
                blue: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    '20C'
                )[2],
                accelerometer_X:
                    Number(
                        playComputerPABytesToSensorData(
                            bytesRecieved.slice(2),
                            '21X'
                        )
                    ) - 32768,
                accelerometer_Y:
                    Number(
                        playComputerPABytesToSensorData(
                            bytesRecieved.slice(2),
                            '21Y'
                        )
                    ) - 32768,
                accelerometer_Z:
                    Number(
                        playComputerPABytesToSensorData(
                            bytesRecieved.slice(2),
                            '21Z'
                        )
                    ) - 32768,
                gyro_X:
                    Number(
                        playComputerPABytesToSensorData(
                            bytesRecieved.slice(2),
                            '21GX'
                        )
                    ) - 2500,
                gyro_Y:
                    Number(
                        playComputerPABytesToSensorData(
                            bytesRecieved.slice(2),
                            '21GY'
                        )
                    ) - 2500,
                gyro_Z:
                    Number(
                        playComputerPABytesToSensorData(
                            bytesRecieved.slice(2),
                            '21GZ'
                        )
                    ) - 2500,
                battery: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    22
                ),
                pcAiTool_read_value: pcAiTool_PABytesToSensorData(
                    bytesRecieved.slice(2),
                    2,
                    this.state.readToggel,
                    this.aiTrainList,
                    {
                        aiSpeechList:
                            this.props?.assembly?.assemblyPageAi?.aiSpeechList,
                        aiFaceList:
                            this.props?.assembly?.assemblyPageAi?.aiFaceList,
                        aiColorList:
                            this.props?.assembly?.assemblyPageAi?.aiColorList,
                    }
                ), //playComputerPABytesToSensorData(bytesRecieved.slice(2), 2),
            })
        } else if (this.connectedDevice == 'Poki') {
            const paDataObj = pokiPABytesToSensorData({
                receivedPABytes: bytesRecieved.slice(2),
                ...this.connectStatusRef.current,
            })

            this.setState(paDataObj)
        } else if (this.connectedDevice == 'Poki') {
            this.setState({
                rangeA1: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    2
                ),
                rangeA2: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    3
                ),
                rangeC1: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    4
                ),
                rangeC2: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    5
                ),
                rangeD1: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    6
                ),
                rangeD2: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    7
                ),
                rangeE1: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    8
                ),
                rangeE2: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    9
                ),
                rangeF1: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    10
                ),
                rangeF2: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    11
                ),
                rangeG1: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    12
                ),
                rangeG2: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    13
                ),
                rangeservo_motor1: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    14
                ),
                rangeservo_motor2: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    15
                ),
                ir: playComputerPABytesToSensorData(bytesRecieved.slice(2), 16),
            })
        } else {
            this.setState({
                rangeA1: mokiPABytesToSensorData(bytesRecieved.slice(2), 2),
                rangeA2: mokiPABytesToSensorData(bytesRecieved.slice(2), 3),
                rangeB1: mokiPABytesToSensorData(bytesRecieved.slice(2), 4),
                rangeB2: mokiPABytesToSensorData(bytesRecieved.slice(2), 5),
                rangeC1: mokiPABytesToSensorData(bytesRecieved.slice(2), 6),
                rangeC2: mokiPABytesToSensorData(bytesRecieved.slice(2), 7),
                rangeD1: mokiPABytesToSensorData(bytesRecieved.slice(2), 8),
                rangeD2: mokiPABytesToSensorData(bytesRecieved.slice(2), 9),
                rangeE1: mokiPABytesToSensorData(bytesRecieved.slice(2), 10),
                rangeE2: mokiPABytesToSensorData(bytesRecieved.slice(2), 11),
                rangeF1: mokiPABytesToSensorData(bytesRecieved.slice(2), 12),
                rangeF2: mokiPABytesToSensorData(bytesRecieved.slice(2), 13),
                rangeG1: mokiPABytesToSensorData(bytesRecieved.slice(2), 14),
                rangeG2: mokiPABytesToSensorData(bytesRecieved.slice(2), 15),
                ir: mokiPABytesToSensorData(bytesRecieved.slice(2), 16),
                switch1: mokiPABytesToSensorData(bytesRecieved.slice(2), 17),
                switch2: mokiPABytesToSensorData(bytesRecieved.slice(2), 18),

                red: mokiPABytesToSensorData(bytesRecieved.slice(2), 19),
                green: mokiPABytesToSensorData(bytesRecieved.slice(2), 20),
                blue: mokiPABytesToSensorData(bytesRecieved.slice(2), 21),

                accelerometer_X:
                    Number(
                        mokiPABytesToSensorData(bytesRecieved.slice(2), 22)
                    ) - 32768,
                accelerometer_Y:
                    Number(
                        mokiPABytesToSensorData(bytesRecieved.slice(2), 23)
                    ) - 32768,
                accelerometer_Z:
                    Number(
                        mokiPABytesToSensorData(bytesRecieved.slice(2), 24)
                    ) - 32768,
                gyro_X:
                    Number(
                        mokiPABytesToSensorData(bytesRecieved.slice(2), 25)
                    ) - 2500,
                gyro_Y:
                    Number(
                        mokiPABytesToSensorData(bytesRecieved.slice(2), 26)
                    ) - 2500,
                gyro_Z:
                    Number(
                        mokiPABytesToSensorData(bytesRecieved.slice(2), 27)
                    ) - 2500,

                magnetometer_X: mokiPABytesToSensorData(
                    bytesRecieved.slice(2),
                    22
                ),
                magnetometer_Y: mokiPABytesToSensorData(
                    bytesRecieved.slice(2),
                    23
                ),
                magnetometer_Z: mokiPABytesToSensorData(
                    bytesRecieved.slice(2),
                    24
                ),
            })
        }

        // this.setState({
        //     rangeA2: playComputerPABytesToSensorData(bytesRecieved.slice(2), 3),
        // })

        // this.setState({
        //     rangeB1: playComputerPABytesToSensorData(bytesRecieved.slice(2), 4),
        // })

        // this.setState({
        //     rangeB2: playComputerPABytesToSensorData(bytesRecieved.slice(2), 5),
        // })

        // this.setState({
        //     rangeC1: playComputerPABytesToSensorData(bytesRecieved.slice(2), 6),
        // })

        // this.setState({
        //     rangeC2: playComputerPABytesToSensorData(bytesRecieved.slice(2), 7),
        // })

        // this.setState({
        //     rangeD1: playComputerPABytesToSensorData(bytesRecieved.slice(2), 8),
        // })

        // this.setState({
        //     rangeD2: playComputerPABytesToSensorData(bytesRecieved.slice(2), 9),
        // })

        // this.setState({
        //     rangeE1: playComputerPABytesToSensorData(
        //         bytesRecieved.slice(2),
        //         10
        //     ),
        // })

        // this.setState({
        //     rangeE2: playComputerPABytesToSensorData(
        //         bytesRecieved.slice(2),
        //         11
        //     ),
        // })

        // this.setState({
        //     rangeF1: playComputerPABytesToSensorData(
        //         bytesRecieved.slice(2),
        //         12
        //     ),
        // })

        // this.setState({
        //     rangeF2: playComputerPABytesToSensorData(
        //         bytesRecieved.slice(2),
        //         13
        //     ),
        // })

        // this.setState({
        //     mic: playComputerPABytesToSensorData(bytesRecieved.slice(2), 14),
        // })

        // this.setState({
        //     temprature: playComputerPABytesToSensorData(
        //         bytesRecieved.slice(2),
        //         15
        //     ),
        // })

        // this.setState({
        //     zero: playComputerPABytesToSensorData(bytesRecieved.slice(2), 16),
        // })

        // this.setState({
        //     one: playComputerPABytesToSensorData(bytesRecieved.slice(2), 17),
        // })

        // this.setState({
        //     temp: playComputerPABytesToSensorData(bytesRecieved.slice(2), 18),
        // })

        // this.setState({
        //     two: playComputerPABytesToSensorData(bytesRecieved.slice(2), 19),
        // })

        // this.setState({
        //     light: playComputerPABytesToSensorData(
        //         bytesRecieved.slice(2),
        //         '20L'
        //     ),
        // })

        // this.setState({
        //     distance: playComputerPABytesToSensorData(
        //         bytesRecieved.slice(2),
        //         '20D'
        //     ),
        // })

        // this.setState({
        //     gesture: playComputerPABytesToSensorData(
        //         bytesRecieved.slice(2),
        //         '20G'
        //     ),
        // })

        // this.setState({
        //     red: playComputerPABytesToSensorData(
        //         bytesRecieved.slice(2),
        //         '20C'
        //     )[0],
        // })

        // this.setState({
        //     green: playComputerPABytesToSensorData(
        //         bytesRecieved.slice(2),
        //         '20C'
        //     )[1],
        // })

        // this.setState({
        //     blue: playComputerPABytesToSensorData(
        //         bytesRecieved.slice(2),
        //         '20C'
        //     )[2],
        // })

        // this.setState({
        //     accelerometer_X:
        //         Number(
        //             playComputerPABytesToSensorData(
        //                 bytesRecieved.slice(2),
        //                 '21X'
        //             )
        //         ) - 32768,
        // })

        // this.setState({
        //     accelerometer_Y:
        //         Number(
        //             playComputerPABytesToSensorData(
        //                 bytesRecieved.slice(2),
        //                 '21Y'
        //             )
        //         ) - 32768,
        // })

        // this.setState({
        //     accelerometer_Z:
        //         Number(
        //             playComputerPABytesToSensorData(
        //                 bytesRecieved.slice(2),
        //                 '21Z'
        //             )
        //         ) - 32768,
        // })

        // this.setState({
        //     gyro_X:
        //         Number(
        //             playComputerPABytesToSensorData(
        //                 bytesRecieved.slice(2),
        //                 '21GX'
        //             )
        //         ) - 2500,
        // })

        // this.setState({
        //     gyro_Y:
        //         Number(
        //             playComputerPABytesToSensorData(
        //                 bytesRecieved.slice(2),
        //                 '21GY'
        //             )
        //         ) - 2500,
        // })

        // this.setState({
        //     gyro_Z:
        //         Number(
        //             playComputerPABytesToSensorData(
        //                 bytesRecieved.slice(2),
        //                 '21GZ'
        //             )
        //         ) - 2500,
        // })

        // this.setState({
        //     battery: playComputerPABytesToSensorData(
        //         bytesRecieved.slice(2),
        //         22
        //     ),
        // })

        //for Ai tool read value

        // this.setState({
        // pcAiTool_read_value: pcAiTool_PABytesToSensorData(
        //     bytesRecieved.slice(2),
        //     2,
        //     this.state.readToggel,
        //     this.aiTrainList
        // ), //playComputerPABytesToSensorData(bytesRecieved.slice(2), 2),
        // })
    }

    //resived PA BYETS for roboki and atr
    recievedBytes_roboki = (bytesRecieved) => {
        let connectedDevice = sessionStorage.getItem('connectedDevice')
        if (connectedDevice == 'Atr') {
            this.setState({
                rangeA1: robokiPABytesToSensorData(bytesRecieved.slice(2), 2),
                rangeA2: robokiPABytesToSensorData(bytesRecieved.slice(2), 3),
                rangeB1: robokiPABytesToSensorData(bytesRecieved.slice(2), 6),
                rangeB2: robokiPABytesToSensorData(bytesRecieved.slice(2), 7),
                rangeC1: robokiPABytesToSensorData(bytesRecieved.slice(2), 23),
                rangeC2: robokiPABytesToSensorData(bytesRecieved.slice(2), 24),
                pcAiTool_read_value: pcAiTool_PABytesToSensorData(
                    bytesRecieved.slice(2),
                    2,
                    this.state.readToggel,
                    this.aiTrainList,
                    {
                        aiSpeechList:
                            this.props?.assembly?.assemblyPageAi?.aiSpeechList,
                        aiFaceList:
                            this.props?.assembly?.assemblyPageAi?.aiFaceList,
                        aiColorList:
                            this.props?.assembly?.assemblyPageAi?.aiColorList,
                    }
                ),
            })
        }
        if (connectedDevice == 'Toki') {
            this.setState({
                rangeA1: robokiPABytesToSensorData(bytesRecieved.slice(2), 2),
                rangeA2: robokiPABytesToSensorData(bytesRecieved.slice(2), 3),
                rangeB1: robokiPABytesToSensorData(bytesRecieved.slice(2), 6),
                rangeservo_motor1: robokiPABytesToSensorData(
                    bytesRecieved.slice(2),
                    6
                ),
                rangeservo_motor2: robokiPABytesToSensorData(
                    bytesRecieved.slice(2),
                    7
                ),
                ir: robokiPABytesToSensorData(bytesRecieved.slice(2), 23),
            })
        } else {
            this.setState({
                rangeA1: robokiPABytesToSensorData(bytesRecieved.slice(2), 2),
                rangeA2: robokiPABytesToSensorData(bytesRecieved.slice(2), 3),
                rangeB1: robokiPABytesToSensorData(bytesRecieved.slice(2), 6),
                rangeB2: robokiPABytesToSensorData(bytesRecieved.slice(2), 7),
                switch1: robokiPABytesToSensorData(bytesRecieved.slice(2), 23),
                switch2: robokiPABytesToSensorData(bytesRecieved.slice(2), 24),
                pcAiTool_read_value: pcAiTool_PABytesToSensorData(
                    bytesRecieved.slice(2),
                    2,
                    this.state.readToggel,
                    this.aiTrainList,
                    {
                        aiSpeechList:
                            this.props?.assembly?.assemblyPageAi?.aiSpeechList,
                        aiFaceList:
                            this.props?.assembly?.assemblyPageAi?.aiFaceList,
                        aiColorList:
                            this.props?.assembly?.assemblyPageAi?.aiColorList,
                    }
                ),
            })
        }
    }

    /////////////////////////////////////////////////////////////////////////////////////
    //resived PA BYETS for Klaw
    componentDidMount() {
        this.connectedDevice =
            sessionStorage.getItem('connectedDevice') || 'Ace'
        // console.log("CALLING componentDidMount :");

        //add the  worker onMessage event
        this.props.worker.addEventListener('message', this.messageHandler)
    }

    componentWillUnmount() {
        this.props.worker.removeEventListener('message', this.messageHandler)
    }

    timeoutPromise = (ms) => {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                console.log('HHHHHHHHHH Time Out')
                reject(new Error('Timeout exceeded'))
            }, ms)
        })
    }

    checkOk = async () => {
        return new Promise(async (resolve, reject) => {
            try {
                while (true) {
                    // let sendData_read = sessionStorage.getItem('sendData_read')
                    let sendData_read = this.sendDataRef.current
                    if (sendData_read) {
                        // sendData_read = JSON.parse(sendData_read)
                        if (sendData_read.sendDataAsPacket) {
                            return resolve(sendData_read.readVal)
                        }
                    }

                    await new Promise((reslove) => {
                        setTimeout(reslove, 100)
                    })
                }
            } catch (e) {
                console.log(e)
            }
        })
    }

    //read data from serial worker
    messageHandler = (e) => {
        if (e.data.type === 'actionRead') {
            let { arrayData, stringData } = e.data.value
            const pattern = /^65,73,.*255,245$/
            const isPatternMatch = pattern.test(arrayData.join(','))
            if (isPatternMatch) {
                this.sendDataRef.current = {
                    sendDataAsPacket: true,
                    readVal: arrayData,
                }
            }
        }

        if (e.data.type == 'PAread') {
            this.recievedBytes_v1(e.data.value)
        } else if (e.data.type == 'RobokiPAread') {
            this.recievedBytes_roboki(e.data.value)
        } else if (e.data.type == 'PAreadPCv0') {
            this.recievedBytes_Pcv01(e.data.value, false)
        } else if (e.data.type === 'read' && e.data.value === '\r\nEÃ¥R\r\n') {
            this.setState({ isRead_v1: false })
            sessionStorage.setItem('isRead', false)
        }
    }

    // call just after components updates
    // STORING RANGE/SEEK bar value with this method
    static getDerivedStateFromProps(props, state) {
        console.log('propsIF', props)

        let mainProps = props.state

        let data = props.state.source

        if (typeof data == 'string') {
            // OLD UI DATA for 4-in-1-sensor
            if (data.split(' ')[0] == '4-IN-1') {
                let myObj = rangeStoreVal['FOUR_in_ONE_Sensor'][`${data}`]
                myObj.condition = mainProps.condition
                myObj.value = mainProps.value
            }

            // NEW UI DATA BELOW
            if (data.split(' ')[0] == 'MICROPHONE') {
                let myObj = rangeStoreVal['MICROPHONE']
                myObj.condition = mainProps.condition
                myObj.value = mainProps.value
            }
            if (data.split(' ')[0] == 'TEMPERATURE') {
                let myObj = rangeStoreVal['TEMPERATURE']
                myObj.condition = mainProps.condition
                myObj.value = mainProps.value
            }
            if (data.split(' ')[0] == 'TOUCH ZERO') {
                let myObj = rangeStoreVal['TOUCH ZERO']
                myObj.condition = mainProps.condition
                myObj.value = mainProps.value
            }
            if (data.split(' ')[0] == 'TOUCH ONE') {
                let myObj = rangeStoreVal['TOUCH ONE']
                myObj.condition = mainProps.condition
                myObj.value = mainProps.value
            }
            if (data.split(' ')[0] == 'TOUCH TWO') {
                let myObj = rangeStoreVal['TOUCH TWO']
                myObj.condition = mainProps.condition
                myObj.value = mainProps.value
            }
            if (data.split(' ')[0] == '4-IN-1 SENSOR  â†’  DIST') {
                let myObj = rangeStoreVal['4-IN-1 SENSOR  â†’  DIST']
                myObj.condition = mainProps.condition
                myObj.value = mainProps.value
            }
            if (data.split(' ')[0] == '4-IN-1 SENSOR  â†’  GESTURE') {
                let myObj = rangeStoreVal['4-IN-1 SENSOR  â†’  GESTURE']
                myObj.condition = mainProps.condition
                myObj.value = mainProps.value
            }

            if (data.split(' ')[0] == '4-IN-1 SENSOR  â†’  LIGHT') {
                let myObj = rangeStoreVal['4-IN-1 SENSOR  â†’  LIGHT']
                myObj.condition = mainProps.condition
                myObj.value = mainProps.value
            }
            if (data.split(' ')[0] == '4-IN-1 SENSOR  â†’  RED') {
                let myObj = rangeStoreVal['4-IN-1 SENSOR  â†’  RED']
                myObj.condition = mainProps.condition
                myObj.value = mainProps.value
            }
            if (data.split(' ')[0] == '4-IN-1 SENSOR  â†’  BLUE') {
                let myObj = rangeStoreVal['4-IN-1 SENSOR  â†’  BLUE']
                myObj.condition = mainProps.condition
                myObj.value = mainProps.value
            }
            if (data.split(' ')[0] == '4-IN-1 SENSOR  â†’  GREEN') {
                let myObj = rangeStoreVal['4-IN-1 SENSOR  â†’  GREEN']
                myObj.condition = mainProps.condition
                myObj.value = mainProps.value
            }
        }
    }

    onChange = (keyOrObj, value) => {
        const { state, onChange } = this.props
        if (state == 'repeat') {
            return
        }

        // 🟢 FIX: Clone the state to prevent in-place mutation!
        const newState = { ...state }

        if (typeof keyOrObj === 'object' && keyOrObj !== null) {
            // Apply batched updates
            Object.assign(newState, keyOrObj)
            if (keyOrObj.source !== undefined) {
                if (
                    [
                        'ai_color_recognition',
                        'ai_face_detection',
                        'ai_face_recognition',
                        'ai_mic',
                    ].includes(keyOrObj.source)
                ) {
                    newState['condition'] = 'eq'
                } else {
                    newState['condition'] = 'gt'
                }
            }
        } else {
            // Apply single update
            newState[keyOrObj] = value

            if (keyOrObj == 'source') {
                if (
                    [
                        'ai_color_recognition',
                        'ai_face_detection',
                        'ai_face_recognition',
                        'ai_mic',
                    ].includes(value)
                ) {
                    newState['condition'] = 'eq'
                } else {
                    newState['condition'] = 'gt'
                }
            }
        }

        onChange(newState, 'sensor')
    }

    onChangeRead = async (key, value) => {
        // FIX: Lock dropdown if tutorial doesn't expect it
        if (
            this.context?.tutorialLocked &&
            !isKeyHighlighted(this.context, 'readDropdownHighlight') &&
            !isKeyHighlighted(this.context, 'readSource')
        )
            return

        const connectedDevice = sessionStorage.getItem('connectedDevice')
        console.log('value=====>', value, key)

        if (this.state.isRead_v1 === true) {
            this.setState({ isRead_v1: false })
            sessionStorage.setItem('isRead', false)
        }

        this.setState({ readToggel: value.trim() })

        // 🟢 FIX: Bubble up the readSource change for tutorial auto-advance
        const { state, onChange } = this.props
        if (state !== 'repeat') {
            const newState = { ...state }
            newState['_readSource'] = value.trim()
            onChange(newState, 'sensor')
        }
    }

    handleOperators = (name) => {
        switch (name) {
            case 'greaterThan': {
                if (this.state.isGraterThan) {
                    this.setState(
                        {
                            isGraterThan: false,
                        },
                        () => {
                            this.onChange('condition', 'gt')
                        }
                    )
                } else {
                    this.setState(
                        {
                            isGraterThan: true,
                            isLessThan: false,
                            isEqualTo: false,
                            isNotequalTo: false,
                            isInBtween: false,
                        },
                        () => {
                            this.onChange('condition', 'gt')
                        }
                    )
                }
                break
            }

            case 'lessThan': {
                if (this.state.isLessThan) {
                    // this.onChange("condition", "lt");

                    this.setState(
                        {
                            isLessThan: false,
                        },
                        () => {
                            this.onChange('condition', 'lt')
                        }
                    )
                } else {
                    this.setState(
                        {
                            isGraterThan: false,
                            isLessThan: true,
                            isEqualTo: false,
                            isNotequalTo: false,
                            isInBtween: false,
                        },
                        () => {
                            this.onChange('condition', 'lt')
                        }
                    )
                }
                break
            }
            case 'equalTo': {
                if (this.state.isEqualTo) {
                    // this.onChange("condition", "eq");

                    this.setState(
                        {
                            isEqualTo: false,
                        },
                        () => {
                            this.onChange('condition', 'eq')
                        }
                    )
                } else {
                    this.setState(
                        {
                            isGraterThan: false,
                            isLessThan: false,
                            isEqualTo: true,
                            isNotequalTo: false,
                            isInBtween: false,
                        },
                        () => {
                            this.onChange('condition', 'eq')
                        }
                    )
                }
                break
            }
            case 'notEqualTo': {
                if (this.state.isNotequalTo) {
                    // this.onChange("condition", "ne");

                    this.setState(
                        {
                            isNotequalTo: false,
                        },
                        () => {
                            this.onChange('condition', 'ne')
                        }
                    )
                } else {
                    this.setState(
                        {
                            isGraterThan: false,
                            isLessThan: false,
                            isEqualTo: false,
                            isNotequalTo: true,
                            isInBtween: false,
                        },
                        () => {
                            this.onChange('condition', 'ne')
                        }
                    )
                }
                break
            }
            case 'inBetween': {
                if (this.state.isInBtween) {
                    // this.onChange("condition", "bw");

                    this.setState(
                        {
                            isInBtween: false,
                        },
                        () => {
                            this.onChange('condition', 'bw')
                        }
                    )
                } else {
                    this.setState(
                        {
                            isGraterThan: false,
                            isLessThan: false,
                            isEqualTo: false,
                            isNotequalTo: false,
                            isInBtween: true,
                        },
                        () => {
                            this.onChange('condition', 'bw')
                        }
                    )
                }
                break
            }
        }
    }

    handleRead = (e) => {
        this.setState({ isRead: !this.state.isRead })
        this.handleReadByte()
        // console.log('READ FRAUD', this.state.isRead)

        // if (this.state.isRead) {
        //     console.log('READER CANCELED')
        //     reader.cancel()
        // } else {
        //     this.readdata()
        // }
    }
    render() {
        const hlInfo = this.context || this.props.panelHighlightInfo;
        const tutorialLocked = !!hlInfo?.tutorialLocked;

        const isLocked = (...keys) => {
            if (!tutorialLocked) return false;
            for (let key of keys) {
                if (isKeyHighlighted(hlInfo, key)) return false;
            }
            return true;
        }

        const lockedStyle = (locked) => locked ? { pointerEvents: 'none', opacity: 0.45 } : {};

        const connectedDevice = sessionStorage.getItem('connectedDevice')
        // let aiTrainList = {}
        // try {
        //     aiTrainList = JSON.parse(localStorage.getItem('aiTrainList'))
        // } catch (e) {
        //     console.log('ERROR', e)
        // }
        // console.log('IF CONDITION PROPS', this.state, this.props.nodeId)
        if (['Humanoid', 'Hexapod', 'Klaw'].includes(connectedDevice)) {
            return (
                <>
                    {this.props.logic.bottomPanel === 'show' &&
                        this.props.nodeId && (
                            <DecisionPanel
                                check={this.props.nodeId}
                                showImage={this.props.showImage}
                            />
                        )}
                </>
            )
        }
        const { state, startState, PortConnections, componentProps } =
            this.props
        var portsConnectedArray = []
        for (var eachConnection in PortConnections) {
            portsConnectedArray.push(eachConnection)
        }

        for (var n = 0; n < portsConnectedArray.length; n++) {
            if (
                portsConnectedArray[n].length == 1 &&
                PortConnections[portsConnectedArray[n]]
            ) {
                if (
                    PortConnections[portsConnectedArray[n]].type !=
                    'dual_splitter'
                ) {
                    if (
                        PortConnections[portsConnectedArray[n]].type ==
                            'ultrasonic_sensor' ||
                        PortConnections[portsConnectedArray[n]].type ==
                            'rotatory'
                    ) {
                        PortConnections[portsConnectedArray[n] + '1'] =
                            PortConnections[portsConnectedArray[n]]
                    }
                    PortConnections[portsConnectedArray[n]] = null
                }
            }
        }

        var sourceOptionsOrder = [],
            readSourceOptionsOrder = [],
            sourceOptions = {}
        sourceOptionsOrder.push('battery')
        readSourceOptionsOrder.push('battery')
        sourceOptions.battery = 'Select Items'
        // if (this.props.state.source != "battery") {
        //   sourceOptionsOrder.pop("battery");
        // }
        Object.keys(PortConnections).forEach((port) => {
            if (port != 'undefined' && PortConnections[port]) {
                if (!PortConnections[port]) return
                var type = PortConnections[port].type

                if (type == 'pcAiTool') {
                    if (['ai_LEDA1', 'ai_audioA1'].includes(port)) {
                        return
                    }
                    let aiItems = this.props.assembly.assemblyPageAi.aiItems
                    // let aiTrainList = JSON.parse(
                    //     localStorage.getItem('aiTrainList')
                    // )
                    Object.keys(aiItemsData).map((objKey) => {
                        if (
                            aiItemsData[objKey].type === 'input' &&
                            aiItems[aiItemsData[objKey].reduxCheck]
                        ) {
                            if (
                                [
                                    // 'ai_face_tracking_X',
                                    // 'ai_face_tracking_Y',
                                    'ai_color_tracking_X',
                                    'ai_color_tracking_Y',
                                ].includes(objKey)
                            ) {
                                // sourceOptionsOrder.push(objKey)
                                // readSourceOptionsOrder.push(objKey)
                                // aiTrainList?.[aiItemsData[objKey].listKey]?.map(
                                //     (ele, ind) => {
                                //         if (ele.isUpload)
                                //             sourceOptionsOrder.push(
                                //                 `${objKey}${ind + 1}`
                                //             )
                                //     }
                                // )
                                if ('ai_color_tracking_Y' !== objKey) {
                                    ;['red', 'green', 'blue']?.map(
                                        (ele, ind) => {
                                            sourceOptionsOrder.push(
                                                `ai_color_tracking_X_${ele}`,
                                                `ai_color_tracking_Y_${ele}`
                                            )
                                            readSourceOptionsOrder.push(
                                                `ai_color_tracking_X_${ele}`,
                                                `ai_color_tracking_Y_${ele}`
                                            )
                                        }
                                    )
                                }
                            } else if (
                                [
                                    'ai_face_tracking_X',
                                    'ai_face_tracking_Y',
                                ].includes(objKey)
                            ) {
                                if (objKey !== 'ai_face_tracking_Y') {
                                    let faceList =
                                        this.props.assembly.assemblyPageAi
                                            .aiFaceList
                                    sourceOptionsOrder.push(objKey)
                                    readSourceOptionsOrder.push(objKey)
                                    sourceOptionsOrder.push(
                                        'ai_face_tracking_Y'
                                    )
                                    readSourceOptionsOrder.push(
                                        'ai_face_tracking_Y'
                                    )
                                    faceList?.map((ele, ind) => {
                                        if (ind !== 0) {
                                            sourceOptionsOrder.push(
                                                `${objKey}${ele.id}`
                                            )
                                            sourceOptionsOrder.push(
                                                `ai_face_tracking_Y${ele.id}`
                                            )
                                            readSourceOptionsOrder.push(
                                                `${objKey}${ele.id}`
                                            )
                                            readSourceOptionsOrder.push(
                                                `ai_face_tracking_Y${ele.id}`
                                            )
                                        }
                                    })
                                }
                            } else {
                                sourceOptionsOrder.push(objKey)
                                readSourceOptionsOrder.push(objKey)
                            }
                        }
                    })
                    //aiItemsData
                } else if (type == 'Magnetometer') {
                    sourceOptionsOrder.push(`Magnetometer_X`)
                    sourceOptionsOrder.push(`Magnetometer_Y`)
                    sourceOptionsOrder.push(`Magnetometer_Z`)

                    readSourceOptionsOrder.push(`Magnetometer_X`)
                    readSourceOptionsOrder.push(`Magnetometer_Y`)
                    readSourceOptionsOrder.push(`Magnetometer_Z`)
                } else if (type == 'IMU') {
                    sourceOptionsOrder.push(
                        `ACCELEROMETER_X`,
                        `ACCELEROMETER_Y`,
                        `ACCELEROMETER_Z`
                    )
                    sourceOptionsOrder.push(`GYRO_X`, `GYRO_Y`, `GYRO_Z`)

                    readSourceOptionsOrder.push(
                        `ACCELEROMETER_X`,
                        `ACCELEROMETER_Y`,
                        `ACCELEROMETER_Z`
                    )
                    readSourceOptionsOrder.push(`GYRO_X`, `GYRO_Y`, `GYRO_Z`)
                } else if (type == 'Color_sensor') {
                    sourceOptionsOrder.push(
                        `COLOUR_SENSOR_(RED)`,
                        `COLOUR_SENSOR_(GREEN)`,
                        `COLOUR_SENSOR_(BLUE)`
                    )

                    readSourceOptionsOrder.push(
                        `COLOUR_SENSOR_(RED)`,
                        `COLOUR_SENSOR_(GREEN)`,
                        `COLOUR_SENSOR_(BLUE)`
                    )
                } else if (IOComponents[type].input) {
                    // console.log('111', port)
                    // console.log('111', componentProps[type].name)

                    if (type == 'temp_dew') {
                        sourceOptionsOrder.push(port)
                        readSourceOptionsOrder.push(port)
                        if (port == 'A1' || port == 'B1' || port == 'C1') {
                            sourceOptions[port] = 'TEMP' + ' \u2192 ' + port
                        } else if (
                            port == 'A2' ||
                            port == 'B2' ||
                            port == 'C2'
                        ) {
                            sourceOptions[port] = 'DEW' + ' \u2192 ' + port
                        } else {
                            sourceOptionsOrder.push(port)
                            readSourceOptionsOrder.push(port)
                            sourceOptions[port] =
                                componentProps[type].name + ' \u2192 ' + port
                        }
                    } else if (type == 'temp_gas') {
                        sourceOptionsOrder.push(port)
                        readSourceOptionsOrder.push(port)
                        if (port == 'A1' || port == 'B1' || port == 'C1') {
                            sourceOptions[port] = 'TEMP' + ' \u2192 ' + port
                        } else if (
                            port == 'A2' ||
                            port == 'B2' ||
                            port == 'C2'
                        ) {
                            sourceOptions[port] = 'GAS' + ' \u2192 ' + port
                        }
                    } else if (
                        [
                            'tern_tact_switch',
                            'tern_touch_sensor',
                            'tern_humidity_sensor',
                            'tern_gas_sensor',
                            'tern_sound_sensor',
                        ].includes(type)
                    ) {
                        let name = componentProps[type].name.replace(
                            'TERN ',
                            ''
                        )
                        sourceOptionsOrder.push(port)
                        readSourceOptionsOrder.push(port)
                        sourceOptions[port] = name + ' \u2192 ' + port
                    } else {
                        sourceOptionsOrder.push(port)
                        readSourceOptionsOrder.push(port)
                        sourceOptions[port] =
                            componentProps[type].name + ' \u2192 ' + port
                    }
                }
            }
        })

        // laxmi sessionstorage

        let sessiondataassemblyCheckbox = JSON.parse(
            sessionStorage.getItem('assemblyCheckbox')
        )
        let sessiondataLogic = JSON.parse(sessionStorage.getItem('logic'))
        let version = sessionStorage.getItem('deviceVersion')

        if (
            sessiondataLogic.bottomPanel == 'border' &&
            this.state.isRead_v1 == true &&
            (version?.startsWith('1') ||
                ['Roboki'].includes(sessionStorage.getItem('connectedDevice')))
        ) {
            this.handleReadByte_v1()
        }
        if (
            sessiondataLogic.bottomPanel == 'border' &&
            this.state.isRead == true &&
            !version?.startsWith('1')
        ) {
            console.log('read', this.state.isRead)
            this.setState({ isRead: !this.state.isRead })
            try {
                reader.cancel()
            } catch (e) {}
        }
        // NEW UI DATA
        let internalaccessoriesData = JSON.parse(
            sessionStorage.getItem('concept')
        ).internalaccessories

        //NEW UI 4-in-1-sensor
        let internalaccessoriesData_Four_in_One_sensor = JSON.parse(
            sessionStorage.getItem('concept')
        ).internalaccessories.Four_in_one_sensor

        // OLD UI DATA 4in1sensore
        if (sessiondataassemblyCheckbox != null) {
            Object.keys(sessiondataassemblyCheckbox).map((val, index) => {
                if (val == 'FOUR_in_ONE_Sensor') {
                    let isChecked = sessiondataassemblyCheckbox[val]

                    if (isChecked == true) {
                        var positionPorts = [
                            '4-IN-1 SENSOR  \u2192  RED',
                            '4-IN-1 SENSOR  \u2192  GREEN',
                            '4-IN-1 SENSOR  \u2192  BLUE',
                            '4-IN-1 SENSOR  \u2192  DIST',
                            '4-IN-1 SENSOR  \u2192  LIGHT',
                            '4-IN-1 SENSOR  \u2192  MOTION',
                        ]
                        for (var i = 0; i < positionPorts.length; i++) {
                            sourceOptionsOrder.push(positionPorts[i])
                            readSourceOptionsOrder.push(positionPorts[i])
                            // sourceOptions[positionPorts[i]] =
                            //   componentProps[type].name + " \u2192 " + positionPorts[i];
                        }
                    }
                }
            })
        }

        try {
            const accessoriesMapping = {
                isTouchZero: ['TouchZero'],
                isTouchOne: ['TouchOne'],
                isTouchTwo: ['TouchTwo'],
                isTouchThree: ['TouchThree'],
                isMic: ['MICROPHONE'],
                isTemperature: ['TEMPERATURE'],
                isAccelerometer: [
                    'ACCELEROMETER_X',
                    'ACCELEROMETER_Y',
                    'ACCELEROMETER_Z',
                    'GYRO_X',
                    'GYRO_Y',
                    'GYRO_Z',
                ],
                isBattery: ['BATTERY'],
                isSwitch1: ['Switch_One'],
                isSwitch2: ['Switch_Two'],
                isIr: ['IR'],
            }

            Object.keys(internalaccessoriesData).forEach((key) => {
                if (internalaccessoriesData[key] && accessoriesMapping[key]) {
                    sourceOptionsOrder.push(...accessoriesMapping[key])
                    readSourceOptionsOrder.push(...accessoriesMapping[key])
                }
            })
        } catch (e) {
            console.error('ERROR', e)
        }

        Object.keys(internalaccessoriesData_Four_in_One_sensor).map(
            (val, index) => {
                if (val == 'isDistanceSensors') {
                    if (internalaccessoriesData_Four_in_One_sensor[val]) {
                        var positionPorts = ['4-IN-1 SENSOR  \u2192  DIST']
                        for (var i = 0; i < positionPorts.length; i++) {
                            sourceOptionsOrder.push(positionPorts[i])
                            readSourceOptionsOrder.push(positionPorts[i])
                        }
                    }
                }
                // laxmi gesture
                if (val == 'isGestureSensor') {
                    if (internalaccessoriesData_Four_in_One_sensor[val]) {
                        var positionPorts = ['4-IN-1 SENSOR  \u2192  GESTURE']
                        for (var i = 0; i < positionPorts.length; i++) {
                            sourceOptionsOrder.push(positionPorts[i])
                            readSourceOptionsOrder.push(positionPorts[i])
                        }
                    }

                    //   this.state.gesture=="1"?<p>Up</p>:this.state.gesture=="2"?
                    // <p>Down</p>:this.state.gesture=="3"?<p>Left</p>:this.state.gesture=="4"?
                    // <p>Right</p>:<p></p>}
                }
                if (val == 'isLightSensor') {
                    if (internalaccessoriesData_Four_in_One_sensor[val]) {
                        var positionPorts = ['4-IN-1 SENSOR  \u2192  LIGHT']
                        for (var i = 0; i < positionPorts.length; i++) {
                            sourceOptionsOrder.push(positionPorts[i])
                            readSourceOptionsOrder.push(positionPorts[i])
                        }
                    }
                }

                if (val == 'isColorSensor') {
                    if (internalaccessoriesData_Four_in_One_sensor[val]) {
                        var positionPorts = [
                            '4-IN-1 SENSOR  \u2192  RED',
                            '4-IN-1 SENSOR  \u2192  BLUE',
                            '4-IN-1 SENSOR  \u2192  GREEN',
                        ]
                        for (var i = 0; i < positionPorts.length; i++) {
                            sourceOptionsOrder.push(positionPorts[i])
                            readSourceOptionsOrder.push(positionPorts[i])
                        }
                    }
                }
            }
        )

        //sourceOptionsOrder.push('irr');
        //sourceOptions.irr = 'IR Remote \u2192 IR';
        Object.keys(startState).forEach((name) => {
            if (name == 'usbrx') {
                if (startState[name]) {
                    var positionPorts = ['USB RX']
                    for (var i = 0; i < positionPorts.length; i++) {
                        sourceOptionsOrder.push(positionPorts[i])
                    }
                }
            }
            if (name == 'btRx') {
                if (startState[name]) {
                    var positionPorts = ['BT RX1']
                    for (var i = 0; i < positionPorts.length; i++) {
                        sourceOptionsOrder.push(positionPorts[i])
                    }
                }
                if (startState[name]) {
                    var positionPorts = ['BT RX2']
                    for (var i = 0; i < positionPorts.length; i++) {
                        sourceOptionsOrder.push(positionPorts[i])
                    }
                }
                if (startState[name]) {
                    var positionPorts = ['BT RX3']
                    for (var i = 0; i < positionPorts.length; i++) {
                        sourceOptionsOrder.push(positionPorts[i])
                    }
                }
                if (startState[name]) {
                    var positionPorts = ['BT RX4']
                    for (var i = 0; i < positionPorts.length; i++) {
                        sourceOptionsOrder.push(positionPorts[i])
                    }
                }
                if (startState[name]) {
                    var positionPorts = ['BT RX5']
                    for (var i = 0; i < positionPorts.length; i++) {
                        sourceOptionsOrder.push(positionPorts[i])
                    }
                }
            }

            if (name === 'btRte') {
                if (startState[name]) {
                    var positionPorts = ['BT Remote']
                    for (var i = 0; i < positionPorts.length; i++) {
                        sourceOptionsOrder.push(positionPorts[i])
                    }
                }
            } else if (name == 'bic1') {
                if (startState[name]) {
                    var positionPorts = ['Bicounter1']
                    for (var i = 0; i < positionPorts.length; i++) {
                        sourceOptionsOrder.push(positionPorts[i])
                    }
                }

                // sourceOptionsOrder.push("Bicounter1");
            } else if (name == 'bic2') {
                if (startState[name]) {
                    var positionPorts = ['Bicounter2']
                    for (var i = 0; i < positionPorts.length; i++) {
                        sourceOptionsOrder.push(positionPorts[i])
                    }
                }
            } else if (name == 'bif1') {
                if (startState[name]) {
                    var positionPorts = ['Biflag1']
                    for (var i = 0; i < positionPorts.length; i++) {
                        sourceOptionsOrder.push(positionPorts[i])
                    }
                }
            } else if (name == 'bif2') {
                if (startState[name]) {
                    var positionPorts = ['Biflag2']
                    for (var i = 0; i < positionPorts.length; i++) {
                        sourceOptionsOrder.push(positionPorts[i])
                    }
                }
            } else if (name == 'bid1') {
                if (startState[name]) {
                    var positionPorts = ['BiData1']
                    for (var i = 0; i < positionPorts.length; i++) {
                        sourceOptionsOrder.push(positionPorts[i])
                    }
                }
            } else if (name == 'bid2') {
                if (startState[name]) {
                    var positionPorts = ['BiData2']
                    for (var i = 0; i < positionPorts.length; i++) {
                        sourceOptionsOrder.push(positionPorts[i])
                    }
                }
            }
        })

        //rearrange the array, bidata1 and bidata2
        if (
            sourceOptionsOrder.includes('BiData1') &&
            sourceOptionsOrder.includes('BiData2')
        ) {
            try {
                let index = sourceOptionsOrder.findIndex((item) =>
                    item.startsWith('BiData')
                )
                let arr1 = sourceOptionsOrder.filter(
                    (item) => item !== 'BiData1' && item !== 'BiData2'
                )
                arr1.splice(index, 0, 'BiData1', 'BiData2')
                sourceOptionsOrder = arr1
            } catch (e) {
                console.log('ERROR', e)
            }
        }

        if (this.props.startState && this.props.startState.slider) {
            sourceOptions.slider = 'BT Slider'
        }

        if (this.props.startState && this.props.startState.bts) {
            sourceOptionsOrder.push('remote')
            sourceOptions.remote = 'BT Speech'
        }
        if (this.props.startState && this.props.startState.btr) {
            sourceOptionsOrder.push('remote')
            sourceOptions.remote = 'BT Remote'
        }

        if (this.props.startState && this.props.startState.iot) {
            for (var i = 1; i <= 10; i++) {
                // sourceOptionsOrder.push('IOT' + i);
                sourceOptions['IOT' + i] = 'IOT' + i
            }
        }
        var conditions,
            max,
            min = 0,
            source = state.source || 'battery'

        conditions = {
            lt: 'Less than',
            gt: 'Greater than',
            eq: 'Equal to',
            ne: 'Not equal to',
        }

        if (source != 'timeElapsed') {
            conditions['bw'] = 'In between'
            //conditions['nbw']='Not in between';
        }
        // if (sourceOptionsOrder.indexOf(source) < 0) source = "slider";
        if (
            source === 'irr' ||
            source.startsWith('bic') ||
            source.startsWith('bid') ||
            source.startsWith('IOT')
        )
            max = 65535
        else if (
            source === 'slider' ||
            source === 'remote' ||
            source === 'time'
        )
            max = 255
        else if (source === 'timeElapsed') max = 2147483
        else if (source === 'battery') max = 0
        else if (source.startsWith('Bif')) max = 1
        else {
            var componentType = localStorage.getItem('biboxTypes')

            // console.log(componentType, "khushboo LOCAL STORAGE");

            var Originalport
            var compName

            //change it to R again
            if (
                source == 'R' ||
                source == 'G' ||
                source == 'B' ||
                source == 'D' ||
                source == 'M' ||
                source == 'L'
            ) {
                Originalport = 'G1'
            } else Originalport = source

            var range
            if (Originalport != undefined || Originalport != null) {
                // OLD UI DATA 4-in1-Sensor
                if (
                    // Originalport == "4-IN-1 SENSOR  â†’  RED" ||
                    // Originalport == "4-IN-1 SENSOR  â†’  GREEN" ||
                    // Originalport == "4-IN-1 SENSOR  â†’  BLUE" ||
                    Originalport == '4-IN-1 SENSOR  â†’  MOTION'
                ) {
                    let data = 'FOUR_in_ONE_Sensor'

                    const str = Originalport
                    const words = str.split(' ')
                    const ports = words[words.length - 1]

                    let activePort = `FOUR_in_ONE_Sensor_${ports}`

                    range = PortValuesRangeMapping[data][activePort]()
                } else if (Originalport == 'Switch_One') {
                    range = PortValuesRangeMapping[Originalport]()
                } else if (Originalport == 'Switch_Two') {
                    range = PortValuesRangeMapping[Originalport]()
                } else if (Originalport == 'IR') {
                    range = PortValuesRangeMapping[Originalport]()
                }
                // NEW UI 4-in-1Sensor data
                else if (Originalport == 'MICROPHONE') {
                    range = PortValuesRangeMapping[Originalport]()
                } else if (Originalport == 'TEMPERATURE') {
                    range = PortValuesRangeMapping[Originalport]()
                } else if (Originalport == 'BATTERY') {
                    range = PortValuesRangeMapping[Originalport]()
                } else if (Originalport == 'ACCELEROMETER_X') {
                    range = PortValuesRangeMapping[Originalport]()
                } else if (Originalport == 'ACCELEROMETER_Y') {
                    range = PortValuesRangeMapping[Originalport]()
                } else if (Originalport == 'ACCELEROMETER_Z') {
                    range = PortValuesRangeMapping[Originalport]()
                } else if (Originalport == 'GYRO_X') {
                    range = PortValuesRangeMapping[Originalport]()
                } else if (Originalport == 'GYRO_Y') {
                    range = PortValuesRangeMapping[Originalport]()
                } else if (Originalport == 'GYRO_Z') {
                    range = PortValuesRangeMapping[Originalport]()
                } else if (Originalport == 'TouchZero') {
                    range = PortValuesRangeMapping['TOUCHZERO']()
                } else if (Originalport == 'TouchOne') {
                    range = PortValuesRangeMapping['TOUCHONE']()
                } else if (Originalport == 'TouchTwo') {
                    range = PortValuesRangeMapping['TOUCHTWO']()
                } else if (Originalport == 'TouchThree') {
                    range = PortValuesRangeMapping['TOUCHTHREE']()
                } else if (Originalport == '4-IN-1 SENSOR  â†’  DIST') {
                    range = PortValuesRangeMapping['FOUR_in_ONE_Sensor_DIST_']()
                } else if (Originalport == '4-IN-1 SENSOR  â†’  GESTURE') {
                    range =
                        PortValuesRangeMapping['FOUR_in_ONE_Sensor_GESTURE_']()
                } else if (Originalport == '4-IN-1 SENSOR  â†’  LIGHT') {
                    range =
                        PortValuesRangeMapping['FOUR_in_ONE_Sensor_LIGHT_']()
                } else if (Originalport == '4-IN-1 SENSOR  â†’  RED') {
                    range = PortValuesRangeMapping['FOUR_in_ONE_Sensor_RED_']()
                } else if (Originalport == '4-IN-1 SENSOR  â†’  BLUE') {
                    range = PortValuesRangeMapping['FOUR_in_ONE_Sensor_BLUE_']()
                } else if (Originalport == '4-IN-1 SENSOR  â†’  GREEN') {
                    range =
                        PortValuesRangeMapping['FOUR_in_ONE_Sensor_GREEN_']()
                } else if (Originalport == 'USB RX') {
                    range = PortValuesRangeMapping['USBRX']()
                } else if (Originalport == 'BT RX1') {
                    range = PortValuesRangeMapping['BTRX1']()
                } else if (Originalport == 'BT RX2') {
                    range = PortValuesRangeMapping['BTRX2']()
                } else if (Originalport == 'BT RX3') {
                    range = PortValuesRangeMapping['BTRX3']()
                } else if (Originalport == 'BT RX4') {
                    range = PortValuesRangeMapping['BTRX4']()
                } else if (Originalport == 'BT RX5') {
                    range = PortValuesRangeMapping['BTRX5']()
                } else if (Originalport == 'Bicounter1') {
                    range = PortValuesRangeMapping['BIC1']()
                } else if (Originalport == 'Bicounter2') {
                    range = PortValuesRangeMapping['BIC2']()
                } else if (Originalport == 'Biflag1') {
                    range = PortValuesRangeMapping['BIF1']()
                } else if (Originalport == 'Biflag2') {
                    range = PortValuesRangeMapping['BIF2']()
                } else if (Originalport == 'BiData1') {
                    range = PortValuesRangeMapping['BID1']()
                } else if (Originalport == 'BiData2') {
                    range = PortValuesRangeMapping['BID2']()
                } else if (Originalport == 'BT Remote') {
                    range = { min: 0, max: 255 }
                } else if (
                    Originalport.includes('Magnetometer') ||
                    Originalport.includes('COLOUR_SENSOR') ||
                    Originalport.includes('ACCELEROMETER') ||
                    Originalport.includes('GYRO')
                ) {
                    let mainPort = 'E1'
                    if (this.connectedDevice === 'Moki') {
                        mainPort = 'D1'
                    }
                    var comp = PortConnections?.[mainPort]?.type

                    var compName = comp?.toLowerCase()

                    range =
                        PortValuesRangeMapping?.[mainPort]?.[compName]?.(
                            Originalport
                        )
                    if (!range) {
                        range = { min: 0, max: 100 }
                    }
                } else if (
                    [
                        'ai_motion',
                        'ai_color_recognition',
                        'ai_face_detection',
                        'ai_face_recognition',
                        'ai_mic',
                        'ai_lidar',
                    ].includes(Originalport) ||
                    Originalport.includes('ai_face_tracking_X') || //ai_face_tracking_X, ai_color_tracking_X
                    Originalport.includes('ai_face_tracking_Y') ||
                    Originalport.includes('ai_color_tracking_X') ||
                    Originalport.includes('ai_color_tracking_Y')
                ) {
                    if (
                        ['ai_motion', 'ai_face_detection', 'ai_lidar'].includes(
                            Originalport
                        ) ||
                        Originalport.includes('ai_face_tracking_X') ||
                        Originalport.includes('ai_face_tracking_Y') ||
                        Originalport.includes('ai_color_tracking_X') ||
                        Originalport.includes('ai_color_tracking_Y')
                    ) {
                        let newOriginalport = Originalport
                        if (Originalport.includes('ai_face_tracking_X')) {
                            newOriginalport = 'ai_face_tracking_X'
                        } else if (
                            Originalport.includes('ai_face_tracking_Y')
                        ) {
                            newOriginalport = 'ai_face_tracking_Y'
                        } else if (
                            Originalport.includes('ai_color_tracking_X')
                        ) {
                            newOriginalport = 'ai_color_tracking_X'
                        } else if (
                            Originalport.includes('ai_color_tracking_Y')
                        ) {
                            newOriginalport = 'ai_color_tracking_Y'
                        }
                        range = {
                            min: aiItemsData[newOriginalport].min,
                            max: aiItemsData[newOriginalport].max,
                        }
                        // range.max = aiItemsData[Originalport].max
                    }
                }
                // else if (
                //     Originalport.includes('Joystick1') ||
                //     Originalport.includes('Joystick2') ||
                //     Originalport.includes('Joystick3')
                // ) {
                //     range = { min: 0, max: 4095 }
                // } else if (
                //     Originalport == 'Switch1' ||
                //     Originalport == 'Switch2' ||
                //     Originalport == 'Switch3'
                // ) {
                //     range = { min: 0, max: 1 }
                // }
                else {
                    // Guard against a source port that isn't connected in the
                    // current assembly (PortConnections[Originalport] === null/
                    // undefined). Without this the whole panel crashes with
                    // "Cannot read properties of null (reading 'type')" — which is
                    // exactly what surfaced in production. Fall back to a safe
                    // range so the panel still renders.
                    var comp = PortConnections?.[Originalport]?.type
                    var compName = comp?.toLowerCase()
                    range =
                        PortValuesRangeMapping?.[Originalport]?.[compName]?.(
                            Originalport
                        )
                    if (!range) {
                        range = { min: 0, max: 100 }
                    }
                }
            } else {
                var comp = PortConnections?.[source]?.type
                var compName = comp?.toLowerCase()
                var range = PortValuesRangeMapping?.[source]?.[compName]?.(source)
                if (!range) {
                    range = { min: 0, max: 100 }
                }
            }
            if (
                ![
                    'ai_color_recognition',
                    'ai_face_recognition',
                    'ai_mic',
                ].includes(Originalport)
            ) {
                min = range.min
                max = range.max
            }
        }

        if (state.value > max) state.value = max

        const ganaretVal = () => {
            // let newVal = value
            // if (state.source == 'ai_face_recognition') {
            //     // newVal = aiTrainList?.faceTranList[value]?.id
            //     return {
            //         //finde index of the object in the faceTranList array
            //         // sliderVal1:
            //         //     aiTrainList?.faceTranList?.findIndex(
            //         //         (obj) => obj?.id === state.value
            //         //     ) + 1 || 0,

            //         // this.props?.assembly?.assemblyPageAi?.aiFaceList?.findIndex(
            //         //     (obj) => obj?.id === state.value
            //         // ) + 1 || 0,
            //         sliderVal2: state.value2 || 0,
            //         conditionValue: state.condition,
            //     }
            // }
            if (
                connectedDevice === 'Ace' &&
                JSON.parse(sessionStorage.getItem('shield'))
            ) {
                if (
                    [
                        'TouchZero',
                        'TouchOne',
                        'TouchTwo',
                        'TouchThree',
                    ].includes(this.props.state.source)
                ) {
                    return {
                        sliderVal1: 0,
                        sliderVal2: 0,
                        conditionValue: 'gt',
                    }
                } else {
                    return {
                        sliderVal1: state.value || 0,
                        sliderVal2: state.value2 || 0,
                        conditionValue: state.condition,
                    }
                }
            } else {
                return {
                    sliderVal1: state.value || 0,
                    sliderVal2: state.value2 || 0,
                    conditionValue: state.condition,
                }
            }
        }
        var ifOutputRow1 = (
                <div>
                    <div
                        style={{
                            top: '50%',
                            width: '100%',
                            position: 'absolute',
                            transform: 'translate(0, -50%)',
                            ...lockedStyle(isLocked('value'))
                        }}
                    >
                        <Slider
                            // value={state.value || 0}
                            value={ganaretVal().sliderVal1}
                            onChange={(value) => {
                                if (isLocked('value')) return // FIX: Lock slider 1
                                this.onChange('value', value)
                            }}
                            max={max}
                            min={min}
                            renderIn="conditionPropertyPanel"
                            sensor={source}
                        />
                    </div>
                    <div
                        style={{
                            position: 'absolute',
                            top: '57.5%',
                            left: '31%',
                            transform: 'translate(-50%,-50%)',
                        }}
                    >
                        <p
                            style={{
                                position: 'absolute',
                                color: 'black',
                            }}
                        >
                            {min}
                        </p>
                    </div>

                    <div
                        style={{
                            position: 'absolute',
                            top: '57.5%',
                            left: '83%',
                            transform: 'translate(-50%,-50%)',
                        }}
                    >
                        <p
                            style={{
                                position: 'absolute',
                                color: 'black',
                            }}
                        >
                            {max}
                        </p>
                    </div>
                </div>
            ),
            ifOutputRow2 = '',
            display = 'inline-block'

        var defaultCssStyle = {
            height: '50px',
            width: '90%',
            marginLeft: '20%',
        }
        if (
            ganaretVal().conditionValue == 'bw' ||
            ganaretVal().conditionValue == 'nbw'
        ) {
            ifOutputRow2 = (
                <>
                    <h5
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            fontSize: '16px',
                            color: 'black',
                            top: '60%',
                            left: '57%',
                            width: '100%',
                            position: 'absolute',
                            transform: 'translate(-50%, -50%)',
                        }}
                    >
                        and
                    </h5>

                    <div
                        style={{
                            top: '65%',
                            width: '100%',
                            position: 'absolute',
                            transform: 'translate(0, -50%)',
                            ...lockedStyle(isLocked('value2'))
                        }}
                        // style={{ height: '5px', width: '90%' }}
                    >
                        <Slider
                            // value={state.value2 || 0}
                            value={ganaretVal().sliderVal2}
                            onChange={(value) => {
                                if (isLocked('value2')) return // FIX: Lock slider 2
                                this.onChange('value2', value)
                            }}
                            max={max}
                            min={min}
                            renderIn="conditionPropertyPanel"
                            sensor={source}
                        />
                    </div>
                    <div
                        style={{
                            position: 'absolute',
                            top: '73.3%',
                            left: '31%',
                            transform: 'translate(-50%,-50%)',
                        }}
                    >
                        <p
                            style={{
                                position: 'absolute',
                                color: 'black',
                            }}
                        >
                            {min}
                        </p>
                    </div>

                    <div
                        style={{
                            position: 'absolute',
                            top: '73.3%',
                            left: '83%',
                            transform: 'translate(-50%,-50%)',
                        }}
                    >
                        <p
                            style={{
                                position: 'absolute',
                                color: 'black',
                            }}
                        >
                            {max}
                        </p>
                    </div>
                </>
            )
        } else {
            ifOutputRow2 = ''
        }

        if (source == 'time') {
            if (state.condition == 'bw' || state.condition == 'nbw') {
                ifOutputRow2 = ''
            } else {
                display = 'none'
                defaultCssStyle = {
                    height: '50px',
                    width: '90%',
                    marginLeft: '40%',
                }
            }
            ifOutputRow1 = (
                <div style={defaultCssStyle}>
                    <span
                        style={{
                            color: 'white',
                            fontWeight: 'bold',
                        }}
                    >
                        {'Hours'}
                    </span>
                    <Select
                        onChange={(value) => {
                            this.onChange('hour', value)
                        }}
                        color={HexTypes['if'].color}
                        options={hours}
                        selected={state.hour}
                    />
                    <span
                        style={{
                            color: 'white',
                            fontWeight: 'bold',
                        }}
                    >
                        {'Min'}
                    </span>
                    <Select
                        onChange={(value) => {
                            this.onChange('minute', value)
                        }}
                        color={HexTypes['if'].color}
                        options={minutes}
                        selected={state.minute}
                    />
                    <span
                        style={{
                            marginLeft: '20%',
                            color: 'white',
                            fontWeight: 'bold',
                            display: display,
                        }}
                    >
                        {'Hours'}
                    </span>
                    <Select
                        style={{ display: display }}
                        onChange={(value) => {
                            this.onChange('hour2', value)
                        }}
                        color={HexTypes['if'].color}
                        options={hours}
                        selected={state.hour2}
                    />
                    <span
                        style={{
                            color: 'white',
                            fontWeight: 'bold',
                            display: display,
                        }}
                    >
                        {'Min'}
                    </span>
                    <Select
                        style={{ display: display }}
                        onChange={(value) => {
                            this.onChange('minute2', value)
                        }}
                        color={HexTypes['if'].color}
                        options={minutes}
                        selected={state.minute2}
                    />
                </div>
            )
        }

        var defaultsourceOptions = ({} = sourceOptions)
        // console.log("KML@@@+++", this.state.readToggel);

        if (
            this.state.readToggel == false ||
            this.state.readToggel == 'battery'
        ) {
            if (
                this.state.readToggel == 'battery' &&
                this.state.isRead == true
            ) {
                this.state.isRead = false
                try {
                    reader.cancel()
                } catch (e) {}
            }
            setTimeout(() => {
                try {
                    document.getElementById('ID').style.pointerEvents = 'none'
                } catch (e) {}
            }, 100)

            console.log('FALLLLSSSE')
        } else {
            // console.log('TRUUUUUUUUUUUUUUUUUUUEEEEE')
            setTimeout(() => {
                try {
                    document.getElementById('ID').style.pointerEvents = 'auto'
                } catch (e) {}
            }, 100)
        }

        //disable the condition img
        const getStyleConditionImg = () => {
            if (
                [
                    'ai_color_recognition',
                    // 'ai_color_tracking',
                    'ai_face_detection',
                    'ai_face_recognition',
                    // 'ai_face_tracking',
                    'ai_mic',
                ].includes(state.source)
            ) {
                return conditionDisabledStyle
            } else {
                return {}
            }
        }

        let tranListOption = ['Select Items']
        try {
            switch (state.source) {
                case 'ai_mic':
                    // aiTrainList?.speechTranList.map((ele) => {
                    //     tranListOption.push(ele.value)
                    // })
                    tranListOption = [
                        ...(this.props?.assembly?.assemblyPageAi
                            ?.aiSpeechList || [{ label: 'Select', id: '0' }]),
                    ]
                    break
                case 'ai_color_recognition':
                    // tranListOption = [{ label: 'Select Ai Color', id: '0' }]
                    // aiTrainList?.colorTranList.map((ele, ind) => {
                    //     if (ele.isUpload)
                    //         tranListOption.push({
                    //             label: `${ele.title} ${ind + 1}`,
                    //             id: ind + 1,
                    //         })
                    // })
                    tranListOption = [
                        ...(this.props?.assembly?.assemblyPageAi
                            ?.aiColorList || [{ label: 'Select', id: '-1' }]),
                    ]
                    break
                case 'ai_face_recognition':
                    //
                    // aiTrainList?.faceTranList.map((ele, ind) => {
                    //     tranListOption.push(`${ele.title}`)
                    // })
                    //|| ['Select Ai Face'])
                    tranListOption = [
                        ...(this.props?.assembly?.assemblyPageAi
                            ?.aiFaceList || [{ label: 'Select', id: '0' }]),
                    ]

                    break
                default:
                    tranListOption = [{ label: 'Select', id: '0' }]
            }
        } catch (e) {
            console.log('ERROR', e)
        }

        // const { state, onChange } = this.props
        // console.log('YYYYYYY222', tranListOption)

        // Tutorial panel highlight
        const _hlInfo = this.context
        const _hlSource = isKeyHighlighted(_hlInfo, 'source')
            ? ' highlight-panel-element'
            : ''

        // Replace your existing _hlCondition variable with these:
        const _hlGt = isConditionHighlighted(_hlInfo, 'condition', 'gt')
            ? 'highlight-panel-condition'
            : ''
        const _hlLt = isConditionHighlighted(_hlInfo, 'condition', 'lt')
            ? 'highlight-panel-condition'
            : ''
        const _hlBw = isConditionHighlighted(_hlInfo, 'condition', 'bw')
            ? 'highlight-panel-condition'
            : ''
        const _hlEq = isConditionHighlighted(_hlInfo, 'condition', 'eq')
            ? 'highlight-panel-condition'
            : ''
        const _hlNe = isConditionHighlighted(_hlInfo, 'condition', 'ne')
            ? 'highlight-panel-condition'
            : ''

        const _hlValue =
            isKeyHighlighted(_hlInfo, 'value') ||
            isKeyHighlighted(_hlInfo, 'value2')
                ? ' highlight-panel-slider'
                : ''
        const _hlRead = isKeyHighlighted(_hlInfo, 'readSource')
            ? ' highlight-panel-element'
            : ''
        const _hlReadDropdown =
            isKeyHighlighted(_hlInfo, 'readDropdownHighlight') ||
            isKeyHighlighted(_hlInfo, 'readDropdownExpand') ||
            isKeyHighlighted(_hlInfo, 'readSource')
                ? ' highlight-panel-element'
                : ''
        const _hlReadBtn =
            isKeyHighlighted(_hlInfo, 'readButtonHighlight') ||
            isKeyHighlighted(_hlInfo, 'readAction')
                ? ' highlight-panel-element'
                : ''

        return (
            <div className="HexDecisionPanel_Container">
                {/* ////////////// show the lowerversion PeeCee ai tool popup /////////////// */}
                {this.state.lowerVersionPcAiToolShow.isShow && (
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            position: 'absolute',
                            color: 'black',
                            width: '400px',
                            minHeight: '150px',
                            zIndex: '1000',
                            padding: '1rem 2rem',
                            background:
                                'linear-gradient(to right, #f0eded, white)',
                            borderRadius: '4rem',
                            border: '1px solid white',
                            boxShadow: '0.5rem 0.5rem 2rem #d9d5d4',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-54%, -36%)',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'right',
                                width: '100%',
                                position: 'relative',
                            }}
                        >
                            <img
                                // className={style.closeBtn}
                                style={{
                                    position: 'absolute',
                                    width: '40px',
                                    top: '-36px',
                                    right: ' -20px',
                                }}
                                src={renderImage('clos')}
                                onClick={() =>
                                    this.setState({
                                        lowerVersionPcAiToolShow: {
                                            isShow: false,
                                            message: '',
                                            type: '',
                                        },
                                    })
                                }
                            />
                        </div>
                        {this.state.lowerVersionPcAiToolShow.type ===
                            'lowerVersion' && (
                            <p>
                                {`AI-1 accessory is not compatible with the current firmware version. Please update the ${getDeviceName(
                                    connectedDevice
                                )} using the firmware updation tool `}
                                <a
                                    href="https://firmware.plode.org"
                                    target="_blank"
                                >
                                    Here.
                                </a>
                            </p>
                        )}
                        {this.state.lowerVersionPcAiToolShow.type ===
                            'text' && (
                            <p>
                                {`Please ensure that, the AI module is properly connected to the ${getDeviceName(
                                    connectedDevice
                                )},  tray again. `}
                            </p>
                        )}
                    </div>
                )}

                {/* done1 */}
                <div
                    style={{
                        position: 'relative',
                        gridTemplateColumns:
                            'ai_mic' == state.source
                                ? '23% 50% 27%'
                                : '30% 50% 20%',
                    }}
                    className={`sub_Container1${_hlSource}`}
                >
                    <div
                        id="content1_text1"
                        style={{
                            color: 'black',
                        }}
                    >
                        <p
                            style={{
                                position: 'absolute',
                                top: '50%',
                                right: '7%',
                                transform: 'translate(0%, -50%)',
                            }}
                        >
                            {'ai_mic' == state.source
                                ? 'If'
                                : 'If the value of'}
                        </p>
                    </div>
                    <div
                        id="content1_text2"
                        style={{
                            color: 'black',
                        }}
                    >
                        <div
                            style={{
                                border: '2px solid black',
                                position: 'absolute',
                                top: '50%',
                                left: '0%',
                                transform: 'translate(0%, -50%)',
                                width: '100%',
                                height: '40%',
                                borderRadius: '15px',
                                fontFamily: 'Halcyon_Medium',
                            }}
                        >
                            <Select
                                onChange={(value) => {
                                    if (isLocked('source')) return // FIX: Lock dropdown
                                    this.onChange({
                                        source: value,
                                        value: 0,
                                        value2: 0,
                                    })
                                }}
                                color={HexTypes['if'].color}
                                options={sourceOptions}
                                order={sourceOptionsOrder}
                                selected={source}
                            />
                        </div>
                    </div>
                    <div
                        id="content1_text3"
                        style={{
                            color: 'black',
                        }}
                    >
                        <p
                            style={{
                                position: 'absolute',
                                top: '50%',
                                left: '7%',
                                transform: 'translate(0, -50%)',
                            }}
                        >
                            {'ai_mic' == state.source ? ' listens to' : 'is'}
                        </p>
                    </div>
                </div>
                {/* done1 */}

                {/* done 2 */}
                <div className={`sub_Container2`}>
                    {ganaretVal().conditionValue == 'gt' ? (
                        <>
                            <div id="content_div1" className={_hlGt}>
                                <img
                                    style={getStyleConditionImg()}
                                    src={renderPrgImage('greaterthanActive')}
                                    onClick={() => {
                                        if (Originalport.includes('Switch'))
                                            return
                                        if (isLocked('condition'))
                                            return // FIX
                                        else this.handleOperators('greaterThan')
                                    }}
                                />
                            </div>
                            <div className={_hlGt}>
                                <p id="sensors-txt1">Greater Than</p>
                            </div>
                        </>
                    ) : (
                        <>
                            <div id="content_div1" className={_hlGt}>
                                <img
                                    style={getStyleConditionImg()}
                                    src={renderPrgImage('greaterthanInActive')}
                                    onClick={() => {
                                        if (
                                            [
                                                'ai_color_recognition',
                                                'ai_face_detection',
                                                'ai_face_recognition',
                                                'ai_mic',
                                                'Switch',
                                            ].includes(Originalport)
                                        )
                                            return
                                        if (isLocked('condition'))
                                            return // FIX
                                        else this.handleOperators('greaterThan')
                                    }}
                                />
                            </div>
                            <div className={_hlGt}>
                                <p id="sensors-txt1">Greater Than</p>
                            </div>
                        </>
                    )}

                    {ganaretVal().conditionValue == 'lt' ? (
                        <>
                            <div id="content_div2" className={_hlLt}>
                                <img
                                    src={renderPrgImage('lessthanActive')}
                                    onClick={() => {
                                        if (Originalport.includes('Switch'))
                                            return
                                        if (isLocked('condition'))
                                            return // FIX
                                        else this.handleOperators('lessThan')
                                    }}
                                />
                            </div>
                            <div className={_hlLt}>
                                <p id="sensors-txt2">Less Than</p>
                            </div>
                        </>
                    ) : (
                        <>
                            <div id="content_div2" className={_hlLt}>
                                <img
                                    style={getStyleConditionImg()}
                                    src={renderPrgImage('lessthanInActive')}
                                    onClick={() => {
                                        if (
                                            [
                                                'ai_color_recognition',
                                                'ai_face_detection',
                                                'ai_face_recognition',
                                                'ai_mic',
                                                'Switch',
                                            ].includes(Originalport)
                                        )
                                            return
                                        if (isLocked('condition'))
                                            return // FIX
                                        else this.handleOperators('lessThan')
                                    }}
                                />
                            </div>
                            <div className={_hlLt}>
                                <p id="sensors-txt2">Less Than</p>
                            </div>
                        </>
                    )}

                    {ganaretVal().conditionValue == 'bw' ? (
                        <>
                            <div id="content_div3" className={_hlBw}>
                                <img
                                    src={renderPrgImage('inbetweenActive')}
                                    onClick={() => {
                                        if (Originalport.includes('Switch'))
                                            return
                                        if (isLocked('condition'))
                                            return // FIX
                                        else this.handleOperators('inBetween')
                                    }}
                                />
                            </div>
                            <div className={_hlBw}>
                                <p id="sensors-txt3">In Between</p>
                            </div>
                        </>
                    ) : (
                        <>
                            <div id="content_div3" className={_hlBw}>
                                <img
                                    style={getStyleConditionImg()}
                                    src={renderPrgImage('inbetweenInActive')}
                                    onClick={() => {
                                        if (
                                            [
                                                'ai_color_recognition',
                                                'ai_face_detection',
                                                'ai_face_recognition',
                                                'ai_mic',
                                                'Switch',
                                            ].includes(Originalport)
                                        )
                                            return
                                        if (isLocked('condition'))
                                            return // 🟢 FIX
                                        else this.handleOperators('inBetween')
                                    }}
                                />
                            </div>
                            <div className={_hlBw}>
                                <p id="sensors-txt3">In Between</p>
                            </div>
                        </>
                    )}

                    {ganaretVal().conditionValue == 'eq' ? (
                        <>
                            <div id="content_div4" className={_hlEq}>
                                <img
                                    src={renderPrgImage('equaltoActive')}
                                    onClick={() => {
                                        if (isLocked('condition')) return // FIX
                                        this.handleOperators('equalTo')
                                    }}
                                />
                            </div>
                            <div className={_hlEq}>
                                <p id="sensors-txt4">Equals To</p>
                            </div>
                        </>
                    ) : (
                        <>
                            <div id="content_div4" className={_hlEq}>
                                <img
                                    src={renderPrgImage('equaltoInActive')}
                                    onClick={() => {
                                        if (isLocked('condition')) return // 🟢 FIX
                                        this.handleOperators('equalTo')
                                    }}
                                />
                            </div>
                            <div className={_hlEq}>
                                <p id="sensors-txt4">Equals To</p>
                            </div>
                        </>
                    )}

                    {ganaretVal().conditionValue == 'ne' ? (
                        <>
                            <div id="content_div5" className={_hlNe}>
                                <img
                                    src={renderPrgImage('notequaltoActive')}
                                    onClick={() => {
                                        if (isLocked('condition')) return // FIX
                                        this.handleOperators('notEqualTo')
                                    }}
                                />
                            </div>
                            <div className={_hlNe}>
                                <p id="sensors-txt5">Not Equals To</p>
                            </div>
                        </>
                    ) : (
                        <>
                            <div id="content_div5" className={_hlNe}>
                                <img
                                    style={getStyleConditionImg()}
                                    src={renderPrgImage('notequaltoInActive')}
                                    onClick={() => {
                                        if (
                                            [
                                                'ai_color_recognition',
                                                'ai_face_detection',
                                                'ai_face_recognition',
                                                'ai_mic',
                                            ].includes(Originalport)
                                        )
                                            return
                                        if (isLocked('condition')) return // FIX
                                        this.handleOperators('notEqualTo')
                                    }}
                                />
                            </div>
                            <div className={_hlNe}>
                                <p id="sensors-txt5">Not Equals To</p>
                            </div>
                        </>
                    )}
                </div>
                {/* done 2 */}

                {![
                    'ai_color_recognition',
                    'ai_face_recognition',
                    'ai_mic',
                ].includes(state.source) && (
                    <div className={`sub-container3${_hlValue}`}>
                        {ifOutputRow1}
                        {ifOutputRow2}
                    </div>
                )}

                {[
                    'ai_color_recognition',
                    'ai_face_recognition',
                    'ai_mic',
                ].includes(state.source) && (
                    <div className={`sub-container3${_hlValue}`}>
                        <div
                            style={{
                                border: '2px solid black',
                                position: 'absolute',
                                top: '61%',
                                left: '15%',
                                transform: 'translate(0%, -50%)',
                                width: '68%',
                                height: '11%',
                                borderRadius: '15px',
                            }}
                        >
                            <Select
                                selected={ganaretVal().sliderVal1}
                                onChange={(value) => {
                                    let newVal = value
                                    if (typeof newVal == 'string') {
                                        newVal = parseInt(newVal)
                                    }
                                    // if (state.source == 'ai_face_recognition') {
                                    // newVal =
                                    //     aiTrainList?.faceTranList?.[
                                    //         value - 1
                                    //     ]?.id

                                    // this.props?.assembly?.assemblyPageAi
                                    //     ?.aiFaceList?.[value - 1]?.id
                                    // }
                                    this.onChange('value', newVal)
                                }}
                                options={sourceOptions}
                                order={tranListOption}
                                typeDropDown="trainList"
                                aiType={state.source}
                            />
                        </div>
                    </div>
                )}

                {/* done4 */}

                <div className={`sub_Container4${_hlRead}`}>
                    <div id="content5_text1">
                        <p
                            style={{
                                // position: 'absolute',
                                // top: '50%',
                                // right: '7%',
                                // transform: 'translate(0%, -50%)',
                                marginBottom: '0px',
                                gap: '4%',
                            }}
                        >
                            Read the
                        </p>
                    </div>
                    <div
                        id="content5_text2"
                        className={_hlReadDropdown || undefined}
                    >
                        <div
                            style={{
                                border: '2px solid black',
                                // position: 'absolute',
                                // top: '50%',
                                // left: '0%',
                                // transform: 'translate(0%, -50%)',
                                // width: '100%',
                                height: '100%',
                                borderRadius: '15px',
                            }}
                        >
                            <Select
                                onChange={(value) => {
                                    if (
                                        isLocked(
                                            'readDropdownHighlight',
                                            'readSource',
                                            'readDropdownExpand'
                                        )
                                    )
                                        return // FIX
                                    this.onChangeRead('source', value)
                                }}
                                options={sourceOptions}
                                order={readSourceOptionsOrder}
                                typeDropDown="read"
                                selected={this.state.readToggel}
                            />
                        </div>
                    </div>
                    <div
                        id="content5_text3"
                        className={_hlReadBtn || undefined}
                    >
                        <div
                            style={{
                                height: '100%',
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            {sessionStorage
                                .getItem('deviceVersion')
                                ?.startsWith('1') ||
                            ['Roboki', 'Atr', 'Toki', 'Poki', 'Moki'].includes(
                                sessionStorage.getItem('connectedDevice')
                            ) ? (
                                <>
                                    {this.state.isRead_v1 ? (
                                        <div
                                            className={`${
                                                connectedDevice == 'Klaw'
                                                    ? 'sub1_content5_klaw'
                                                    : 'sub1_content5 center_div_items'
                                            }`}
                                        >
                                            <div
                                                className="center_div_items"
                                                style={{
                                                    // position: 'absolute',
                                                    // top: '55%',
                                                    // left: '31%',
                                                    // transform:
                                                    //     'translate(0, -50%)',
                                                    fontSize: '2vh',
                                                    color: 'black',
                                                    minWidth: '30px',
                                                    height: '20px',
                                                }}
                                                onClick={() => {
                                                    if (
                                                        isLocked(
                                                            'readButtonHighlight',
                                                            'readAction'
                                                        )
                                                    )
                                                        return // FIX
                                                    if (
                                                        this.props.webSerial
                                                            .isConnected
                                                    )
                                                        this.handleReadByte_v1()

                                                    const { state, onChange } =
                                                        this.props
                                                    if (state !== 'repeat') {
                                                        onChange(
                                                            {
                                                                ...state,
                                                                _readAction: true,
                                                            },
                                                            'sensor'
                                                        )
                                                    }
                                                }}
                                            >
                                                {this.state.readToggel ===
                                                'A1' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.rangeA1}
                                                    </p>
                                                ) : this.state.readToggel ===
                                                  'A2' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.rangeA2}
                                                    </p>
                                                ) : this.state.readToggel ===
                                                  'B1' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.rangeB1}
                                                    </p>
                                                ) : this.state.readToggel ===
                                                  'B2' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.rangeB2}
                                                    </p>
                                                ) : this.state.readToggel ===
                                                  'C1' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.rangeC1}
                                                    </p>
                                                ) : this.state.readToggel ===
                                                  'C2' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.rangeC2}
                                                    </p>
                                                ) : this.state.readToggel ===
                                                  'D1' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.rangeD1}
                                                    </p>
                                                ) : this.state.readToggel ===
                                                  'D2' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.rangeD2}
                                                    </p>
                                                ) : this.state.readToggel ===
                                                  'E1' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.rangeE1}
                                                    </p>
                                                ) : this.state.readToggel ===
                                                  'E2' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.rangeE2}
                                                    </p>
                                                ) : this.state.readToggel ===
                                                  'F1' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                            textAlign: 'center',
                                                        }}
                                                    >
                                                        {this.state.rangeF1}
                                                    </p>
                                                ) : this.state.readToggel ===
                                                  'F2' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.rangeF2}
                                                    </p>
                                                ) : this.state.readToggel ===
                                                  'G1' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                            textAlign: 'center',
                                                        }}
                                                    >
                                                        {this.state.rangeG1}
                                                    </p>
                                                ) : this.state.readToggel ===
                                                  'G2' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.rangeG2}
                                                    </p>
                                                ) : this.state.readToggel ===
                                                  'TouchZero' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.zero}
                                                    </p>
                                                ) : this.state.readToggel ==
                                                  'TouchOne' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.one}
                                                    </p>
                                                ) : this.state.readToggel ===
                                                  'TouchTwo' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.two}
                                                    </p>
                                                ) : this.state.readToggel ===
                                                  'TouchThree' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.temp}
                                                    </p>
                                                ) : this.state.readToggel ===
                                                  'BATTERY' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.battery}
                                                    </p>
                                                ) : this.state.readToggel ===
                                                  'MICROPHONE' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.mic}
                                                    </p>
                                                ) : this.state.readToggel ===
                                                  'TEMPERATURE' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.temprature}
                                                    </p>
                                                ) : this.state.readToggel ===
                                                  'ACCELEROMETER_X' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {
                                                            this.state
                                                                .accelerometer_X
                                                        }
                                                    </p>
                                                ) : this.state.readToggel ===
                                                  'ACCELEROMETER_Y' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {
                                                            this.state
                                                                .accelerometer_Y
                                                        }
                                                    </p>
                                                ) : this.state.readToggel ===
                                                  'ACCELEROMETER_Z' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {
                                                            this.state
                                                                .accelerometer_Z
                                                        }
                                                    </p>
                                                ) : this.state.readToggel ===
                                                  'GYRO_X' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.gyro_X}
                                                    </p>
                                                ) : this.state.readToggel ===
                                                  'GYRO_Y' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.gyro_Y}
                                                    </p>
                                                ) : this.state.readToggel ===
                                                  'GYRO_Z' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.gyro_Z}
                                                    </p>
                                                ) : this.state.readToggel ===
                                                  '4-IN-1 SENSOR  â†’  BLUE' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.blue}
                                                    </p>
                                                ) : this.state.readToggel ===
                                                  '4-IN-1 SENSOR  â†’  GREEN' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.green}
                                                    </p>
                                                ) : this.state.readToggel ===
                                                  '4-IN-1 SENSOR  â†’  RED' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.red}
                                                    </p>
                                                ) : this.state.readToggel ===
                                                  '4-IN-1 SENSOR  â†’  LIGHT' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.light}
                                                    </p>
                                                ) : this.state.readToggel ===
                                                  '4-IN-1 SENSOR  â†’  GESTURE' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.gesture}
                                                    </p>
                                                ) : this.state.readToggel ===
                                                  '4-IN-1 SENSOR  â†’  DIST' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.distance}
                                                    </p>
                                                ) : this.state.readToggel ===
                                                  'Switch_One' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.switch1}
                                                    </p>
                                                ) : this.state.readToggel ===
                                                  'Switch_Two' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.switch2}
                                                    </p>
                                                ) : this.state.readToggel ===
                                                  'servo_motor1' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {
                                                            this.state
                                                                .rangeservo_motor1
                                                        }
                                                    </p>
                                                ) : this.state.readToggel ===
                                                  'servo_motor2' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {
                                                            this.state
                                                                .rangeservo_motor2
                                                        }
                                                    </p>
                                                ) : [
                                                      'ai_color_recognition',
                                                      'ai_color_tracking_X',
                                                      'ai_color_tracking_Y',
                                                      'ai_face_tracking_X',
                                                      'ai_face_tracking_Y',
                                                      //   'ai_face_tracking_X1',
                                                      //   'ai_face_tracking_Y1',
                                                      //   'ai_face_tracking_X2',
                                                      //   'ai_face_tracking_Y2',
                                                      //   'ai_face_tracking_X3',
                                                      //   'ai_face_tracking_Y3',
                                                      'ai_face_detection',
                                                      'ai_face_recognition',
                                                      'ai_mic',
                                                      'ai_lidar',
                                                      'ai_motion',
                                                      'ai_color_tracking_X_red',
                                                      'ai_color_tracking_X_green',
                                                      'ai_color_tracking_X_blue',
                                                      'ai_color_tracking_Y_red',
                                                      'ai_color_tracking_Y_green',
                                                      'ai_color_tracking_Y_blue',
                                                  ].includes(
                                                      this.state.readToggel
                                                  ) ||
                                                  this.state.readToggel.includes(
                                                      'ai_face_tracking_'
                                                  ) ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {
                                                            this.state
                                                                .pcAiTool_read_value
                                                        }
                                                    </p>
                                                ) : this.state.readToggel ===
                                                  'IR' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.ir}
                                                    </p>
                                                ) : null}
                                            </div>
                                        </div>
                                    ) : (
                                        <div
                                            className={`${
                                                connectedDevice == 'Klaw'
                                                    ? 'sub2_content5_klaw'
                                                    : 'sub2_content5 center_div_items'
                                            }`}
                                        >
                                            <div
                                                id="ID"
                                                className="center_div_items"
                                                style={{
                                                    // position: 'absolute',
                                                    // top: '48%',
                                                    // left: '25%',
                                                    // transform:
                                                    //     'translate(0, -50%)',
                                                    fontSize: '2vh',
                                                }}
                                                onClick={() => {
                                                    if (
                                                        isLocked(
                                                            'readButtonHighlight',
                                                            'readAction'
                                                        )
                                                    )   {
                                                        console.log('Read action is locked');
                                                        return // FIX
                                                    }
                                                    this.handleReadByte_v1()
                                                    const { state, onChange } =
                                                        this.props
                                                    if (state !== 'repeat') {
                                                        onChange(
                                                            {
                                                                ...state,
                                                                _readAction: true,
                                                            },
                                                            'sensor'
                                                        )
                                                    }
                                                }}
                                            >
                                                Read
                                            </div>
                                        </div>
                                    )}
                                </>
                            ) : (
                                <>
                                    {' '}
                                    {this.state.isRead ? (
                                        <div className="sub1_content5 center_div_items">
                                            {' '}
                                            <div
                                                className="center_div_items"
                                                style={{
                                                    // position: 'absolute',
                                                    // top: '55%',
                                                    // left: '31%',
                                                    // transform:
                                                    //     'translate(0, -50%)',
                                                    fontSize: '2vh',
                                                    color: 'black',
                                                    minWidth: '30px',
                                                }}
                                                onClick={() => {
                                                    if (
                                                        isLocked(
                                                            'readButtonHighlight',
                                                            'readAction'
                                                        )
                                                    )
                                                        return // FIX
                                                    this.handleRead()
                                                    const { state, onChange } =
                                                        this.props
                                                    if (state !== 'repeat') {
                                                        onChange(
                                                            {
                                                                ...state,
                                                                _readAction: true,
                                                            },
                                                            'sensor'
                                                        )
                                                    }
                                                }}
                                            >
                                                {this.state.readToggel ==
                                                'A1' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.rangeA1}
                                                    </p>
                                                ) : this.state.readToggel ==
                                                  'A2' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.rangeA2}
                                                    </p>
                                                ) : this.state.readToggel ==
                                                  'B1' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.rangeB1}
                                                    </p>
                                                ) : this.state.readToggel ==
                                                  'B2' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.rangeB2}
                                                    </p>
                                                ) : this.state.readToggel ==
                                                  'C1' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.rangeC1}
                                                    </p>
                                                ) : this.state.readToggel ==
                                                  'C2' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.rangeC2}
                                                    </p>
                                                ) : this.state.readToggel ==
                                                  'F1' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.rangeF1}
                                                    </p>
                                                ) : this.state.readToggel ==
                                                  'F2' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.rangeF2}
                                                    </p>
                                                ) : this.state.readToggel ==
                                                  'TouchZero' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.zero}
                                                    </p>
                                                ) : this.state.readToggel ==
                                                  'TouchOne' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.one}
                                                    </p>
                                                ) : this.state.readToggel ==
                                                  'TouchTwo' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.two}
                                                    </p>
                                                ) : this.state.readToggel ==
                                                  'MICROPHONE' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.mic}
                                                    </p>
                                                ) : this.state.readToggel ==
                                                  'TEMPERATURE' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.temprature}
                                                    </p>
                                                ) : this.state.readToggel ==
                                                  '4-IN-1 SENSOR  â†’  BLUE' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.blue}
                                                    </p>
                                                ) : this.state.readToggel ==
                                                  '4-IN-1 SENSOR  â†’  GREEN' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.green}
                                                    </p>
                                                ) : this.state.readToggel ==
                                                  '4-IN-1 SENSOR  â†’  RED' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.red}
                                                    </p>
                                                ) : this.state.readToggel ==
                                                  '4-IN-1 SENSOR  â†’  LIGHT' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.light}
                                                    </p>
                                                ) : this.state.readToggel ==
                                                  '4-IN-1 SENSOR  â†’  GESTURE' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {gestureValueToText(
                                                            this.outputGesture(
                                                                this.state
                                                                    .gesture
                                                            )
                                                        )}
                                                    </p>
                                                ) : this.state.readToggel ==
                                                  '4-IN-1 SENSOR  â†’  DIST' ? (
                                                    <p
                                                        style={{
                                                            marginBottom:
                                                                '0px ',
                                                        }}
                                                    >
                                                        {this.state.distance}
                                                    </p>
                                                ) : null}
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="sub2_content5 center_div_items">
                                            <div
                                                id="ID"
                                                className="center_div_items"
                                                style={{
                                                    // position: 'absolute',
                                                    // top: '48%',
                                                    // left: '25%',
                                                    // transform:
                                                    //     'translate(0, -50%)',
                                                    fontSize: '2vh',
                                                }}
                                                // onMouseDown={async () => {
                                                //     const PLAY = [
                                                //         'P'.charCodeAt(),
                                                //         'L'.charCodeAt(),
                                                //         'A'.charCodeAt(),
                                                //         'Y'.charCodeAt(),
                                                //     ]
                                                //     await this.writePort(PLAY)
                                                // }}
                                                onClick={async (e) => {
                                                    if (
                                                        isLocked(
                                                            'readButtonHighlight',
                                                            'readAction'
                                                        )
                                                    )
                                                        return // FIX
                                                    const updateFW = JSON.parse(
                                                        sessionStorage.getItem(
                                                            'updateFW'
                                                        )
                                                    )
                                                    if (
                                                        updateFW === null ||
                                                        updateFW === false
                                                    ) {
                                                        if (
                                                            !this.props
                                                                .webSerial
                                                                .isConnected
                                                        )
                                                            return
                                                        await this.handleRead()

                                                        const {
                                                            state,
                                                            onChange,
                                                        } = this.props
                                                        if (
                                                            state !== 'repeat'
                                                        ) {
                                                            onChange(
                                                                {
                                                                    ...state,
                                                                    _readAction: true,
                                                                },
                                                                'sensor'
                                                            )
                                                        }

                                                        let ele = e.target
                                                        ele.style.pointerEvents =
                                                            'none'
                                                        setTimeout(() => {
                                                            ele.style.pointerEvents =
                                                                'all'
                                                        }, 2000)
                                                    } else {
                                                        this.props.popUp(true)
                                                    }
                                                }}
                                            >
                                                Read
                                            </div>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </div>
                {/* done4 */}
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    console.log('ASSEMBLY LOG', state)
    return state
}

const mapDispatchToProps = (dispatch) => {
    return {
        webSerialConnect: (data) => {
            dispatch(webSerialConnect(data))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(IfPanel)
